/* UPGRD V14 — gedrag van de productpagina.

   Vanilla JS, geen frameworks. De referentie draait op een component met state
   en rerendert; hier gebeurt hetzelfde met data-attributen en klassen, zodat de
   markup uit Liquid komt en alleen de toestand hier zit.

   Eén ding dat anders moet dan in de referentie: de offer-module staat twee keer
   op de pagina. In de referentie is dat één component met één state. Hier zijn
   het twee losse stukken DOM, dus de keuze wordt gespiegeld — kiest iemand boven
   Salted Caramel, dan staat dat onderaan ook. Anders koopt iemand iets anders
   dan hij denkt.
*/
(function () {
  'use strict';

  /* EEN GRENDEL TEGEN DUBBEL DRAAIEN. Twee <script src> met dezelfde URL voert de
     browser twee keer uit -- de tweede haalt het bestand uit de cache maar draait
     hem wel. Dit blad bindt klikluisteraars, dus dan hangt er aan elke koopknop
     twee keer dezelfde handler en vuurt één klik twee wagenverzoeken af.
     Dat kan echt gebeuren: de offerbalk laadt dit script en de homepage-hero ook,
     en op de homepage staan die twee secties samen op één pagina. De sectie die
     als tweede rendert is dan de dubbele. In plaats van te vertrouwen op wie waar
     staat, weigert het script hier gewoon een tweede keer te draaien. */
  if (window.__upgrdV14Draait) return;
  window.__upgrdV14Draait = true;

  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* WAAROM HIER GEEN KALE PADEN STAAN.
     Shopify: "If you've hardcoded a URL like /cart in a link or Ajax request,
     then visitors browsing in another language or market context will be forced
     back to the domain defaults." Zolang er één markt en één taal is doet dat
     niets, maar op de dag dat er een tweede bijkomt rekent elke bezoeker daar in
     de verkeerde valuta af, of valt hij terug naar de homepage. window.routes
     wordt door het thema in layout/theme.liquid gezet; Shopify.routes.root
     draagt het taalvoorvoegsel. */
  var pad = function (naam) {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    if (naam === 'checkout') return r + 'checkout';
    if (naam === 'cart') return (window.routes && window.routes.cart_url) || (r + 'cart');
    return r + naam;
  };

  var lees = function (el, naam) { try { return JSON.parse(el.getAttribute(naam) || '{}'); } catch (e) { return {}; } };
  var alle = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ── de scrollgrendel ──────────────────────────────────────────────────────
     Het ingrediëntenpaneel en de lightbox vergrendelen allebei de achtergrond
     met documentElement.style.overflow. Dat was een schakelaar en geen teller:
     stonden ze allebei open en sloot je er één, dan draaide die ene de grendel
     om voor allebei en schoof de pagina onder de andere dialoog gewoon weg.
     Daarom houdt deze ene plek bij WIE er op slot heeft gezet; de grendel gaat
     er pas af als de laatste eigenaar loslaat.
     Met opzet een verzameling namen en geen ++/--: het paneel kan met het
     toetsenbord een tweede tegel openen zonder eerst te sluiten, en dan draait
     toon() twee keer en dicht() één keer. Een getal zou op 1 blijven staan en
     de pagina voorgoed op slot zetten; een naam kan niet dubbel geteld worden. */
  var grendelaars = {};
  var grendel = function (wie, aan) {
    if (aan) grendelaars[wie] = 1; else delete grendelaars[wie];
    document.documentElement.style.overflow = Object.keys(grendelaars).length ? 'hidden' : '';
  };

  /* ── focus vasthouden in een dialoog ──────────────────────────────────────
     PUNT 4.2. Beide dialogen dragen role="dialog" aria-modal="true", en die
     belofte is pas waar als de focus er ook echt in zit. Twee helpers, want de
     lightbox en het ingredientenpaneel hebben precies dezelfde behoefte.

     tabbaar() geeft de tabstops binnen een dialoog, in documentvolgorde.
     :not([disabled]) is geen netheid maar noodzaak: de pijlen in de lightbox
     worden op de eerste en de laatste video uitgezet, en een uitgezette knop mag
     geen schakel in de ronde zijn. Het maatfilter houdt weggeklapte elementen
     buiten de deur — punt 4.1 zet display:none op de dichte lightbox.

     klem() doet alleen het randgeval: staat de focus op de laatste en gaat hij
     vooruit, dan terug naar de eerste, en omgekeerd met Shift. Al het andere
     laat hij aan de browser, zodat de volgorde binnen de dialoog die van het
     document blijft. Is de focus de dialoog ontglipt, dan haalt de eerste Tab
     hem weer naar binnen; dat gebeurt echt, want een pijl in de lightbox zet
     zichzelf uit terwijl hij de focus heeft en dan valt de focus op <body>.

     Staat de focus binnen de dialoog op iets wat NIET in de lijst staat, dan
     doet klem() niets. Dat is geen slordigheid: Chromium maakt een scrollbak
     zonder focusbare kinderen zelf tabbaar, en .v14-sheet__body is dat zodra de
     uitleg niet past — gemeten op een liggende telefoon van 844x390. Zou klem()
     die focus naar f[0] trekken, dan was de oranje knop in de voet met Tab
     onbereikbaar. De bak staat tussen de sluitknop en de knop in de voet, dus de
     browser houdt de focus daar zelf binnen de dialoog. */
  var tabbaar = function (wortel) {
    return alle('a[href],button:not([disabled]),video[controls],[tabindex]:not([tabindex="-1"])', wortel)
      .filter(function (el) { return !el.hidden && (el.offsetWidth || el.offsetHeight || el.getClientRects().length); });
  };
  var klem = function (wortel, e) {
    if (e.key !== 'Tab') return;
    var f = tabbaar(wortel);
    if (!f.length) return;
    if (!wortel.contains(document.activeElement)) {
      e.preventDefault(); (e.shiftKey ? f[f.length - 1] : f[0]).focus(); return;
    }
    var i = f.indexOf(document.activeElement);
    if (i < 0) return;
    if (e.shiftKey && i === 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
  };

  /* ── offerbalk: twee berichten, elke 4,5s wisselen ───────────────────────── */
  alle('[data-v14-bar]').forEach(function (bar) {
    var msgs = alle('.v14-bar__msg', bar);
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      var vorige = i;
      i = (i + 1) % msgs.length;
      msgs.forEach(function (m, j) {
        m.setAttribute('data-on', j === i ? 'true' : 'false');
        m.setAttribute('aria-hidden', j === i ? 'false' : 'true');
        /* het bericht dat net weg is schuift naar boven, de rest wacht onderaan */
        m.setAttribute('data-above', j === vorige ? 'true' : 'false');
      });
    }, 4500);
  });

  /* ── header: verbergen bij omlaag scrollen, op elke breedte ──────────────── */
  var hdr = document.querySelector('[data-v14-header]');
  /* Het element dat plakt is de sectiewikkel, niet de header. Daar hoort dus ook
     het verbergen op te staan, anders schuift alleen de inhoud weg terwijl de
     wikkel blijft staan. Valt terug op de header zelf, voor de theme editor en
     voor een losse render zonder wikkel. */
  var hdrPlak = hdr && (hdr.closest('.upgrd-v14-hdrwrap') || hdr);
  if (hdr) {
    var laatst = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY, d = y - laatst;
      if (Math.abs(d) < 6) return;          /* drempel uit de referentie */
      laatst = y;
      /* OOK OP DESKTOP. Dit stond op "alleen onder 1024px", want een volle witte
         balk die op een breed scherm wegschuift en terugkomt is onrustig. De
         kop is nu twee zwevende pillen over de inhoud, en dan is wegschuiven
         juist het punt: zo geeft hij het beeld eronder vrij. Nagemeten op de
         pagina die de klant aanwees: die schuift op 1440 bij elke omlaagse
         beweging volledig weg (translate 0 -100%) en komt bij omhoog terug. */
      var verberg = d > 0 && y > 240;
      hdrPlak.setAttribute('data-hide', verberg ? 'true' : 'false');
    }, { passive: true });
  }

  /* ── de winkelwagenlade ───────────────────────────────────────────────────
     De lade van het thema (sections/cart-drawer-v1.liquid) hangt via
     layout/theme.liquid:631 op ELKE pagina van de winkel, dus ook op deze. V14
     deed er alleen niets mee: de twee wagenknoppen navigeerden naar /cart. Wie
     na het afrekenen terugklikt en even wil zien wat er ligt, verliet daarmee
     de pagina. Nu schuift de lade open.

     DE KOOPKNOP BLIJFT ONGEMOEID en gaat nog steeds rechtstreeks naar de kassa.
     Dit gaat alleen over het BEKIJKEN van de wagen.

     De knoppen blijven echte links naar /cart. Zo doen ze nog iets zinnigs als
     het script faalt, en blijven rechtermuisknop, middelklik en cmd-klik doen
     wat de bezoeker verwacht; alleen de gewone linkerklik wordt onderschept, en
     alleen als de lade er werkelijk is. */
  alle('[data-v14-cartlink]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var lade = window.cartDrawerV1;
      if (!lade || typeof lade.open !== 'function') return;
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      /* METEEN OPENEN. Hier werd eerst de wagen opnieuw gelezen en pas daarna
         geopend. Nagemeten op 13 oktober 2026: dat duurde ruim drie seconden,
         want de wagen van Shopify doet er 500 tot 900ms over en er stonden er
         meerdere tegelijk open. Drie seconden niets zien na een tik voelt kapot.

         open() leest zelf al opnieuw, en tekent de lade bij als het antwoord er
         is. De bezoeker ziet dus meteen zijn wagen, en wat er veranderd is komt
         er een halve tel later bij in plaats van ervoor. */
      lade.open();
    });
  });

  /* ── de knop in de lege wagen ─────────────────────────────────────────────
     Het id is vast: Shopify geeft een sectie uit {% section 'x' %} de id 'x', en
     de lade plakt daar 'cart-drawer-v1-' voor. Hetzelfde id staat in de css.

     HIER STOND MEER. Tot 13 oktober 2026 zat hier ook de correctie van de
     doorgestreepte som in de lade: een waarnemer die bij elke wijziging de wagen
     opnieuw ophaalde en daarna de bedragen overschreef. Die is verhuisd naar de
     lade zelf (getOfferCompareSubtotal in cart-drawer-v1.liquid), omdat hij daar
     in dezelfde ronde gerekend wordt. Hier kostte hij drie extra wagenlezingen
     per opening en liet hij de bezoeker drie bedragen achter elkaar zien. */
  (function () {
    var ladeWortel = document.getElementById('cart-drawer-v1-cart-drawer-v1');
    if (!ladeWortel) return;

    /* DE KNOP IN DE LEGE WAGEN, OOK OP DEZE PAGINA KLOPPEND.
       Die knop staat op "Save 50% + Free Shipping" en wijst naar
       /products/creatinecoffee. Allebei komt uit config/settings_data.json, en
       dat geldt WINKELBREED — daar kan dit dus niet gewijzigd worden zonder elke
       andere pagina mee te nemen. Daarom hier, en alleen hier.

       Het percentage wordt niet ingetypt maar uit de standaardtrede van deze
       pagina gehaald, dezelfde bron als het lint. Zet iemand het lint ooit op
       een ander getal, dan schuift deze knop mee in plaats van stil achter te
       blijven op een oude claim.

       En de bestemming is de pagina zelf, via het eigen pad. Zo wijst hij
       vandaag naar deze pagina mét ?view=upgrd-v14, en vanzelf naar de nieuwe
       URL zodra dit sjabloon live staat — zonder dat iemand eraan hoeft te
       denken. Wil je er iets anders laten staan, dan is dit de enige plek. */
    /* De module hier zelf opzoeken en niet via de variabele `modules`: dit blok
       staat VOOR de regel die die variabele vult, dus daar stond hij nog op
       undefined. Dat kostte een uitzondering, en omdat alles in deze IIFE zit
       nam die de rest van het script mee — koopblokken en galerij incluis. */
    var eersteOffer = document.querySelector('[data-v14-offer]');
    var legeKnop = ladeWortel.querySelector('.cart_drawer_v1__empty-link');
    if (legeKnop && eersteOffer) {
      var standaardQty = String(Number(eersteOffer.getAttribute('data-qty') || 60));
      var PL = (lees(eersteOffer, 'data-prices') || {})[standaardQty] || {};
      var pctL = String(PL.save || '').replace(/[^0-9]/g, '');
      if (pctL) legeKnop.textContent = 'Save ' + pctL + '% + Free Shipping';
      legeKnop.setAttribute('href', window.location.pathname + window.location.search);
    }
  })();

  /* De lade roept deze hook aan bij elke telwijziging, en hij is hier vrij: hij
     hoort bij sections/header_v1, en de header-group van dit sjabloon is leeg.
     Mocht er ooit toch iemand anders op zitten, dan blijft die gewoon werken. */
  var vorigeTeller = window.headerV1UpdateCartCount;
  window.headerV1UpdateCartCount = function (aantal) {
    var n = Number(aantal) || 0;
    alle('[data-v14-cartcount]').forEach(function (el) {
      el.textContent = String(n);
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
    if (typeof vorigeTeller === 'function') { try { vorigeTeller(n); } catch (e) {} }
  };

  /* ── de offer-modules ─────────────────────────────────────────────────────── */
  var modules = alle('[data-v14-offer]');
  var staat = null;

  function naam(f) { return f === 'c' ? 'Salted Caramel' : f === 'm' ? 'Both (1 Original + 1 Salted Caramel)' : 'Original'; }
  function kort(f) { return f === 'c' ? 'Salted Caramel' : f === 'm' ? 'Both' : 'Original'; }

  function levering() {
    var d = new Date(Date.now() + 4 * 864e5);
    return d.toLocaleDateString('en-US', { weekday: 'long' });
  }

  /* De regels die bij de huidige keuze horen. Eén plek, want de koopknop en de
     synchronisatie voor de portemonneeknoppen moeten per definitie hetzelfde
     in de wagen leggen; twee kopieën zouden vroeg of laat uit elkaar lopen. */
  /* De tweede parameter is nieuw. Het koopblok heeft één gedeelde keuze (`staat`)
     omdat er twee modules op de pagina staan die elkaar spiegelen. De homepage
     biedt dezelfde producten heel anders aan: drie kaarten die elk hun eigen
     smaak en aantal dragen, en alleen het abonnement/eenmalig wisselt mee. Die
     kaarten geven hun keuze dus expliciet mee. Zonder argument blijft het precies
     zoals het was -- gemeten: de vier kortingsgevallen in de lade zijn gelijk. */
  function regelsVoorKeuze(m, keuze) {
    var k = keuze || staat;
    var vars = lees(m, 'data-variants');
    var plans = lees(m, 'data-plans');
    var gifts = lees(m, 'data-gifts');
    var sub = k.mode === 'sub';
    var plan = sub ? plans[String(k.qty)] : null;

    /* ELKE REGEL WORDT GEMERKT, anders haalt de lade de cadeaus er weer uit.
       removeUnearnedOfferGifts in sections/cart-drawer-v1.liquid draait op elke
       paginalading en op beide afrekenknoppen, en veegt daar elke regel weg die
       niets kost en wel verzending vraagt — en dat zijn de schep en de beker
       precies. Zonder eigenschappen kwamen ze dus wel in de wagen en lagen ze er
       een seconde later uit. Zelfde contract als upgrd-combo-buy.js rond regel
       726, want die bewaking kent maar één taal:

         _upgrd_offer  'free' op een cadeau, 'paid' op een verkochte regel.
                       'free' is wat de lade als cadeau herkent; het merk zelf
                       haalt bovendien de aantalkiezer van deze regels af en
                       laat het hele pakket in één klik weggaan.
         _upgrd_pool   alles wat dit aanbod ÓÓIT weggeeft. Hoort er ook te staan
                       bij een eenmalige aankoop, die verdient er namelijk geen
                       enkele; zo wordt een schep die iemand er zelf bij legt
                       alsnog opgeruimd.
         _upgrd_free   wat DEZE keuze verdient. De bewaking telt dit per betaalde
                       regel OP, dus het staat op precies één regel: bij "Both"
                       op beide pouches zou de wagen twee scheppen vrijgeven.

       Komma-string zonder ruimte, net als combo-buy; de bewaking trimt zelf. */
    var pool = [gifts.scoop, gifts.cup]
      .map(Number)
      .filter(function (n) { return isFinite(n) && n > 0; });

    var cadeaus = [];
    if (sub && gifts.scoop) cadeaus.push(gratis(gifts.scoop));
    if (sub && k.qty === 60 && gifts.cup) cadeaus.push(gratis(gifts.cup));

    var sleutel = sub ? 'sub' : 'once';
    var betaalde = [];
    if (k.flavor === 'm') {
      betaalde.push(betaald(vars.o[sleutel], 1, plan));
      betaalde.push(betaald(vars.c[sleutel], 1, plan));
    } else {
      betaalde.push(betaald(vars[k.flavor][sleutel], k.qty === 30 ? 1 : 2, plan));
    }

    /* ALLEEN MERKEN ALS ER IETS TE BESCHERMEN VALT.
       Deze drie eigenschappen bestaan om de cadeaus overeind te houden tegen
       removeUnearnedOfferGifts in de wagenlade. Een eenmalige aankoop heeft geen
       cadeaus, dus daar beschermen ze niets — en ze kostten daar wel wat: de
       regel kreeg _upgrd_free als LEGE string mee, wat de enige inhoudelijke
       afwijking was tussen de eenmalige payload en de abonnementspayload die het
       wel deed. Een eigenschap met een lege waarde is bovendien nergens goed
       voor: removeUnearnedOfferGifts leest hem als `|| ''` en komt op precies
       hetzelfde uit als wanneer hij er niet staat.

       Het merk 'paid' heeft ook een prijs die bij een eenmalige aankoop niets
       oplevert: de lade haalt er de aantalkiezer van af (cart-drawer-v1:1681) en
       laat één verwijderklik de hele regel wegnemen (:1957). Zinnig bij een
       pakket met cadeaus, zinloos bij één losse regel.

       Dus: bij een abonnement de volledige boekhouding, bij een eenmalige
       aankoop exact de payload van vóór 10 oktober — {id, quantity} en verder
       niets. */
    if (cadeaus.length) {
      /* De boekhouding op de EERSTE betaalde regel, niet op een cadeau: een
         cadeauregel die zijn eigen recht meedraagt keurt zichzelf goed. */
      betaalde[0].properties._upgrd_pool = pool.join(',');
      betaalde[0].properties._upgrd_free = cadeaus.map(function (c) { return c.id; }).join(',');

      /* DE REKENBASIS VAN HET LINT, MEE DE WAGEN IN.
         Het lint zegt "Get 62% Off", maar de wagenlade ziet alleen de pouches:
         $90 die $49 worden, en dat is 46%. Het verschil is geen fout maar een
         andere grondslag — het lint rekent de cadeaus en de verzending mee:
         $90 + $34 + $4,95 = $128,95, en $49 daarvan is exact 62%. Hetzelfde
         klopt voor 30 servings: $45 + $7 + $4,95 = $56,95 tegen $29 is 49%.

         Die grondslag staat nergens als los getal, maar hij is exact af te
         leiden uit twee instellingen die er wél zijn: prijs / (1 - percentage).
         Zo blijft er één bron en gaan lint en lade nooit uit elkaar lopen als
         iemand het percentage of de prijs wijzigt.

         _upgrd_now gaat mee zodat de lade kan zien of er NOG ligt wat dit aanbod
         erin legde. Wijzigt de bezoeker daar een aantal, dan klopt de grondslag
         niet meer en laat de lade haar eigen som weer zien. */
      var prijzen = lees(m, 'data-prices') || {};
      var grondslag = function (q) {
        var P = prijzen[String(q)] || {};
        var pct = parseFloat(String(P.save || '').replace(/[^0-9.]/g, ''));
        var nu = Math.round(parseFloat(String(P.sub || '').replace(/[^0-9.]/g, '')) * 100);
        if (!(pct > 0 && pct < 100 && nu > 0)) return null;
        return { nu: nu, compare: Math.round(nu / (1 - pct / 100)) };
      };
      var gB = grondslag(k.qty);
      if (gB) {
        betaalde[0].properties._upgrd_compare = String(gB.compare);
        betaalde[0].properties._upgrd_now = String(gB.nu);
      }

      /* DE TREDENLADDER, MEE DE WAGEN IN.
         De lade krijgt een plus en een min op de betaalde regel. Van twee
         pouches naar een is geen aantalwijziging maar een ander aanbod: andere
         planprijs ($29 in plaats van $24,50 per pouch) en een cadeau minder.
         Wie dat alleen als aantal behandelt verkoopt een pouch voor $24,50 met
         $34 aan cadeaus erbij.

         Daarom reist de hele ladder mee op de regel, en kan de lade zelf
         omschakelen zonder iets van deze pagina te weten. Per trede:
         aantal:plan:cadeau-ids:prijs:vanafprijs, treden gescheiden door een
         puntkomma.

         ALLEEN BIJ EEN ENKELE SMAAK. "Both" legt twee betaalde regels neer van
         elk een pouch en bestaat niet bij 30 servings, dus daar is geen trede om
         heen te schakelen; die regels houden hun vaste aantal. */
      if (k.flavor !== 'm') {
        var treden = [30, 60].map(function (q) {
          var plan = plans[String(q)];
          var g = grondslag(q);
          if (!plan || !g) return '';
          var cadeauIds = [gifts.scoop];
          if (q === 60 && gifts.cup) cadeauIds.push(gifts.cup);
          cadeauIds = cadeauIds.map(Number).filter(function (n) { return isFinite(n) && n > 0; });
          if (!cadeauIds.length) return '';
          return [q === 30 ? 1 : 2, plan, cadeauIds.join(','), g.nu, g.compare].join(':');
        }).filter(Boolean);
        if (treden.length > 1) betaalde[0].properties._upgrd_ladder = treden.join(';');
      }
    } else {
      betaalde.forEach(function (r) { delete r.properties; });
    }

    /* Cadeaus eerst, daarna de betaalde regels — exact de volgorde van hiervoor,
       want de lade tekent de wagen in deze volgorde. */
    return cadeaus.concat(betaalde);
  }

  function gratis(id) {
    return { id: id, quantity: 1, properties: { _upgrd_offer: 'free' } };
  }

  /* _upgrd_basis is het aantal pouches dat DIT aanbod verkoopt: een bij 30
     servings, twee bij 60. De lade heeft dat nodig zodra er een aantalkiezer op
     deze regel staat, want de min mag niet onder het pakket zakken.

     Waarom het meegestuurd wordt en niet afgeleid: het plan rekent per pouch,
     dus na een wijziging is uit de regel zelf niet meer te zien met hoeveel hij
     begon. Een getal dat bij het aanbod hoort hoort dus bij het aanbod gezet te
     worden, op het moment dat het nog klopt. */
  function betaald(id, aantal, plan) {
    var regel = { id: id, quantity: aantal,
      properties: { _upgrd_offer: 'paid', _upgrd_basis: String(aantal) } };
    if (plan) regel.selling_plan = Number(plan);
    return regel;
  }

  function teken() {
    if (!staat) return;
    var f = staat.flavor, q = String(staat.qty), sub = staat.mode === 'sub';

    modules.forEach(function (m) {
      var P = lees(m, 'data-prices')[q];
      if (!P) return;

      m.setAttribute('data-flavor', f);
      m.setAttribute('data-qty', q);
      m.setAttribute('data-mode', staat.mode);

      alle('[data-v14-flavor]', m).forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-v14-flavor') === f ? 'true' : 'false');
        /* PUNT 4: "Both" bestaat alleen bij 60 servings. 30 servings is één zak,
           dus twee pouches aanbieden slaat daar nergens op. De kaart verdwijnt
           in plaats van gedimd te worden — de klant vraagt hem niet te tonen. */
        if (b.hasAttribute('data-v14-alleen60')) b.hidden = staat.qty !== 60;
      });
      alle('[data-v14-qty]', m).forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-v14-qty') === q ? 'true' : 'false');
        /* 30 hoeft niet meer gedimd: Both is er bij 30 niet, dus de combinatie
           die dit moest afvangen kan niet meer ontstaan. */
        b.removeAttribute('data-dim');
      });
      alle('[data-v14-mode]', m).forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-v14-mode') === staat.mode ? 'true' : 'false');
      });

      /* PUNT 4.3: roving tabindex. Een radiogroep is één tabstop, niet één per
         knop — dat is wat role="radio" belooft en wat een echte <input
         type="radio"> ook doet. Deze ene lus bedient alle drie de groepen in
         beide koopblokken, en hij staat hier omdat teken() óók bij het laden
         draait (js:406): dan is de begintoestand meteen goed en hoeft er in de
         Liquid geen tabindex te staan. Gemeten: 7 tabstops per koopblok worden 3. */
      alle('[role="radio"]', m).forEach(function (b) {
        b.tabIndex = b.getAttribute('aria-checked') === 'true' ? 0 : -1;
      });

      var zet = function (sel, waarde) { var el = m.querySelector(sel); if (el) el.textContent = waarde; };
      zet('[data-v14-qname]', q + ' servings');
      zet('[data-v14-was]', P.once);
      zet('[data-v14-subnow]', P.sub);
      zet('[data-v14-oncenow]', P.once);
      zet('[data-v14-per]', P.per);
      /* PUNT 7 vraagt "Price / Price per day" bij de eenmalige aankoop. Dat
         bedrag stond hard in de opmaak op $1,50 en liep dus niet mee met het
         aantal; dat het vandaag bij 30 en 60 servings toevallig hetzelfde
         uitkomt maakt het niet minder fout. En de twee opties stonden in
         verschillende eenheden naast elkaar — per serving tegen per dag —
         terwijl juist de vergelijking het doel is. Een serving is een kop per
         dag, dus beide dragen nu / day. */
      var totaal = parseFloat(String(P.once).replace(/[^0-9.]/g, ''));
      if (totaal > 0 && q > 0) zet('[data-v14-onceper]', '$' + (totaal / q).toFixed(2));

      /* PUNT 6: het lint draagt de besparing, en die MOET bij het gekozen aantal
         horen — een koper van 30 servings bespaart 49% en mag geen 62% lezen.
         P.save staat als "Save 62%" in het template; het lint zegt "Get 62% Off",
         dus alleen het percentage eruit. */
      zet('[data-v14-lint]', String(P.save).replace(/[^0-9]+/g, '') + '%');

      zet('[data-v14-subline]', q + ' Servings · Every 4 Weeks');
      zet('[data-v14-onceline]', q + ' Servings · Delivered Once');

      /* PUNT 8: verlengprijs, frequentie en opzegvrijheid onder de koopknop.
         Zonder ingevulde verlengprijs blijft de frequentie staan, want die is
         ook zonder bedrag waar.

         HET BEDRAG STAAT PER SERVING EN NIET MEER ALS TOTAAL. Hier stond
         "Renews at $66 each 4 weeks."; de klant geeft aan dat zij de
         verlenging per serving wilde zien, en dat staat ook zo in haar eigen
         offerdocument, dat de prijsregel van het abonnement als "$0.82 /
         serving" uitschrijft. De bewoording eromheen komt uit datzelfde
         document: "Refills Every 4 Weeks" en "Pause or Cancel Anytime".

         HET WORDT GEREKEND EN NIET INGESTELD, met dezelfde parse-en-deel als
         de regel hierboven voor de eenmalige prijs. Een apart veld zou een
         tweede plek zijn waar hetzelfde bedrag staat, en dan kan het gaan
         verschillen van de verlengprijs waar het uit volgt. $66 bij 60
         servings geeft $1.10, $36 bij 30 geeft $1.20. Lukt het rekenen niet,
         dan valt de zin terug op de versie zonder bedrag. */
      var verlengTot = parseFloat(String(P.verleng).replace(/[^0-9.]/g, ''));
      var verlengPer = (verlengTot > 0 && q > 0) ? '$' + (verlengTot / q).toFixed(2) : '';
      zet('[data-v14-refillstx]', (verlengPer ? 'Refills every 4 weeks at ' + verlengPer + ' per serving. ' : 'Refills every 4 weeks. ')
        + 'Pause or cancel anytime.');
      zet('[data-v14-perk0]', P.perks);
      zet('[data-v14-arrive]', levering());
      /* ALLE KOOPKNOPPEN ZEGGEN HETZELFDE. Hier stond "Get 60 servings · $49"
         op de knop in dit blok, terwijl de knop onder de galerij "Start now ·
         Just $49" zei. De klant wil overal de tweede. Het aantal valt daarmee
         uit de knop weg, maar het staat al op de gekozen kaart erboven, in de
         planregel eronder en in de wagen.

         DOCUMENT-BREED EN NIET MET zet(). zet() zoekt binnen deze module en de
         knop onder de galerij staat daarbuiten, dus die had een eigen regel
         nodig; precies zo zijn die twee teksten ooit uit elkaar gaan lopen.
         Eén schrijfactie voor allebei kan dat niet meer. De lus draait één keer
         per module en schrijft dan twee keer hetzelfde, wat goedkoper is dan de
         waarde buiten de lus nog een keer uitrekenen. */
      alle('[data-v14-ctalabel]', document).forEach(function (el) {
        el.textContent = 'Start now · Just ' + (sub ? P.sub : P.once);
      });

      var refills = m.querySelector('[data-v14-refills]');
      if (refills) refills.hidden = !sub;
    });

    /* het eerste galerijbeeld volgt de combinatie */
    var gal = document.querySelector('[data-v14-gal]');
    if (gal) {
      var shots = lees(gal, 'data-shots');
      var shot = shots[(staat.qty === 30 ? 1 : 2) + '-' + f];
      /* ook het beeld in het laatste koopblok draagt data-v14-slide="0" en volgt
         dus dezelfde combinatie; vandaar document en niet gal */
      /* EEN DIA KAN TWEE VORMEN HEBBEN.
         In de galerij staat sinds 13 oktober 2026 een echt <img> met alt-tekst,
         omdat een achtergrondbeeld niet in Google Afbeeldingen komt. Het beeld
         in het laatste koopblok is nog wel een achtergrond. Deze functie bedient
         allebei, zodat er maar één plek is die weet hoe een dia wisselt. */
      var zetDia = function (el, opname) {
        var img = el.querySelector('img');
        el.style.backgroundColor = opname.bg;
        if (img) {
          if (opname.set) img.srcset = opname.set;
          img.src = opname.src;
          img.alt = opname.alt;
        } else {
          el.style.backgroundImage = 'url(' + opname.src + ')';
          el.setAttribute('aria-label', opname.alt);
        }
      };
      var zetDuim = function (nr, opname) {
        alle('[data-v14-thumb="' + nr + '"]', document).forEach(function (t) {
          t.style.backgroundColor = opname.bg;
          t.style.backgroundImage = 'url(' + opname.src + ')';
        });
      };

      var eerste = gal.querySelector('[data-v14-slide="0"]');
      var extra = alle('[data-v14-slide="0"]').filter(function (x) { return !gal.contains(x); });
      if (shot && eerste) {
        [eerste].concat(extra).forEach(function (el) { zetDia(el, shot); });
        zetDuim(0, shot);
      }

      /* DE DIA DIE LAAT ZIEN WAT ER IN DE DOOS ZIT.
         Hij wisselt mee met de smaak, en hij hoort alleen bij 60 servings: de
         opname toont twee cadeaus en de prijs van die trede. Bij 30 servings
         gaat hij dus weg, samen met zijn duimnagel.

         Welke plek hij heeft staat niet hier maar in de galerijlijst van de
         sectie, als de regel {smaak}. Dia en duimnagel dragen daar een merk, en
         dat is het enige waar deze code op afgaat.

         Na het verbergen worden de overgebleven dia's en duimnagels opnieuw
         genummerd. De schuif rekent met die nummers: zonder hernummering wijst
         duimnagel 5 na het wegvallen van nummer 3 naar het verkeerde beeld. */
      var smaakKaart = lees(gal, 'data-smaakdia');
      var smaakOpname = smaakKaart[(staat.qty === 30 ? 1 : 2) + '-' + f];
      var smaakDia = gal.querySelector('[data-v14-smaakdia]');
      if (smaakDia) {
        var toonSmaak = staat.qty === 60;
        var smaakDuimen = alle('[data-v14-smaakduim]', document);
        smaakDia.hidden = !toonSmaak;
        smaakDuimen.forEach(function (t) { t.hidden = !toonSmaak; });
        if (toonSmaak && smaakOpname) {
          zetDia(smaakDia, smaakOpname);
          smaakDuimen.forEach(function (t) {
            t.style.backgroundColor = smaakOpname.bg;
            t.style.backgroundImage = 'url(' + smaakOpname.src + ')';
          });
        }
        alle('[data-v14-slide]', gal)
          .filter(function (d) { return !d.hidden; })
          .forEach(function (d, i) { d.setAttribute('data-v14-slide', i); });
        alle('.v14-gal__vrail, .v14-gal__hrail', document).forEach(function (rail) {
          alle('[data-v14-thumb]', rail)
            .filter(function (t) { return !t.hidden; })
            .forEach(function (t, i) {
              t.setAttribute('data-v14-thumb', i);
              t.setAttribute('aria-label', 'Show image ' + (i + 1));
            });
        });
      }
      /* terug naar beeld 1, zoals pickReset in de referentie */
      var spoor = gal.querySelector('[data-v14-track]');
      if (spoor) spoor.scrollTo({ left: 0, behavior: 'auto' });
    }

    /* de mobiele koopbalk toont dezelfde keuze */
    /* De onderkop in de hero noemt het aantal servings. Die staat BUITEN de
       offer-module, dus hij gaat niet door zet() heen — die kijkt alleen binnen
       m. Hij stond vast op 30 terwijl 60 de standaardkeuze is, dus de eerste
       zin die een bezoeker las sprak de knop eronder tegen. */
    alle('[data-v14-subqty]').forEach(function (el) { el.textContent = q; });

    var balk = document.querySelector('[data-v14-buybar]');
    if (balk) {
      var r1 = balk.querySelector('[data-v14-barline]');
      /* alleen de regel loopt mee met de keuze. De knop houdt zijn eigen tekst:
         punt 24 vraagt om "Shop now", en dat is ook het eerlijke woord, want de
         knop koopt niet maar springt naar het koopblok waar de keuze staat. */
      if (r1) r1.textContent = q + ' servings · ' + kort(f) + (sub ? ' · subscribe' : '');
    }

  }

  /* ── de wagen vullen ──────────────────────────────────────────────────────
     DEZE VIER STONDEN BINNEN if (modules.length) HIERONDER. Daar hoorden ze
     zolang alleen de productpagina kocht. De koopkaarten van de homepage doen
     sinds 11 okt 2026 hetzelfde: legen, vullen, nalezen, door naar de kassa.
     Die pagina heeft geen [data-v14-offer], dus dat blok draaide daar nooit en
     bestonden deze functies niet. In strikte modus is een functie in een blok
     ook echt tot dat blok beperkt, dus hergebruiken kon alleen door ze een
     niveau omhoog te halen. Voor de productpagina verandert er niets: zelfde
     functies, zelfde aanroepen, alleen een scope ruimer. */
  /* Wagen legen en opnieuw vullen. Dit doet ÉÉN ding, en met opzet: de vorige
     versie vroeg in dezelfde aanroep ook de opnieuw gerenderde secties op, en
     toen een van die twee faalde bleef de hele keten hangen. Gevolg: de
     portemonneeknoppen stonden permanent op slot. Vullen is de kritieke stap en
     mag nergens anders van afhangen. */
  function leesWagen() {
    return fetch(pad('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        /* De winkel schuift er soms een botcontrole tussen; dat is HTML, geen JSON. */
        if (!t || t.charAt(0) !== '{') throw new Error('cart.js gaf geen json');
        return JSON.parse(t);
      });
  }

  /* Ligt er precies in wat er gekozen is? Niet "er ligt iets": tussen het
     legen en het vullen is de wagen even leeg, en een trage eerdere ronde mag
     niet op een halfgevulde wagen "klaar" roepen. */
  function wagenKloptMet(regels, wagen) {
    if (!wagen || !wagen.items) return false;
    if (wagen.items.length !== regels.length) return false;
    return regels.every(function (r) {
      return wagen.items.some(function (it) {
        /* PUNT 1.9: óók het verkoopplan vergelijken. Zonder dit kwam een
           abonnement dat onderweg stilletjes een eenmalige aankoop werd als
           "klopt" door de controle en ging het gewoon naar de kassa. De wagen
           geeft het plan terug als selling_plan_allocation.selling_plan.id;
           ontbreekt die, dan is 0 de juiste vergelijking met een regel zonder
           plan. */
        if (Number(it.id) !== Number(r.id) || it.quantity !== r.quantity) return false;
        var ip = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
        return Number((ip && ip.id) || 0) === Number(r.selling_plan || 0);
      });
    });
  }

  /* EERST EEN WAGEN LATEN BESTAAN, DAARNA PAS SCHRIJVEN.
     Zolang er geen wagen-cookie is maakt elk verzoek zijn eigen wagen aan.
     Gemeten op een verse sessie: één laadbeurt leverde ZES verschillende
     cart-tokens op, want naast ons schrijven er ook een heatmap- en een
     trackingapp naar de wagen. Gevolg: een lege wagen terwijl de pagina dacht
     van niet, een afrekening zonder regels, en de klant op de homepage.

     HIER STOND DAT ÉÉN LEESACTIE DIE COOKIE VASTLEGT. DAT IS ONJUIST,
     nagemeten op 6 oktober 2026: een GET /cart.js zet alleen cart_currency, en
     twee leesacties achter elkaar geven twee VERSCHILLENDE tokens. Lezen maakt
     geen wagen.

     Wat het wel doet is POST /cart/update.js met één leeg attribuut. Gemeten:
     status 200, cookie `cart` gezet, nul regels in de wagen, attributes {} en
     geen note — hij brengt de wagen tot bestaan en laat geen spoor na op de
     bestelling. Pas daarna raken clear en add gegarandeerd dezelfde wagen. */
  function maakWagen() {
    return fetch(pad('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { upgrd: '' } }),
    }).then(function (r) {
      if (!r.ok) throw new Error('wagen aanmaken ' + r.status);
      return r.json();
    });
  }

  function zetWagen(m, keuze) {
    /* SNELHEID. Deze keten stond op vier verzoeken ACHTER ELKAAR voordat er ook
       maar iets naar de kassa ging: update (wagen laten bestaan), clear, add, en
       dan cart.js om na te lezen. Vier keer de latency, en wagen-endpoints van
       Shopify zijn traag — op een echte winkel 1,5 tot 3,5 seconde staan kijken
       naar een knop die "Adding…" zegt.

       Twee daarvan kunnen weg zonder de bescherming op te geven.

       Hier de eerste: maakWagen bestaat omdat zonder wagen-cookie elk verzoek
       zijn EIGEN wagen aanmaakt, en omdat lezen die cookie niet zet. Maar
       clear.js is zelf een POST naar de wagen en doet dus precies hetzelfde:
       hij brengt de wagen tot bestaan en zet de cookie. Legen we toch al — en
       dat is de standaard — dan is de aparte update-aanroep een rondje voor
       niets. Staat legen uit, dan is add.js de eerste POST en blijft maakWagen
       wél nodig, want anders kan die add in een andere wagen landen dan waar de
       browser naar wijst. */
    var legen = m.getAttribute('data-leeg') !== 'false';
    var begin = legen
      ? fetch(pad('cart/clear.js'), { method: 'POST', headers: { Accept: 'application/json' } })
          .then(function (r) {
            /* maakWagen keek hiervoor wél naar de status; dat mag niet wegvallen
               nu clear.js de eerste stap is. Een mislukte clear betekent dat de
               oude regels blijven staan, en dan legt add.js er zijn regels
               naast in plaats van ervoor in de plaats. */
            if (!r.ok) throw new Error('wagen legen ' + r.status);
            return r;
          })
      : maakWagen();
    return begin.then(function () {
      return fetch(pad('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: regelsVoorKeuze(m, keuze) }),
      }).then(function (r) {
        /* 409 en 429 zijn geen gewone fouten maar "probeer het zo nog eens".
           409 geeft Shopify sinds 10 oktober 2025 terug bij te veel
           gelijktijdige wagen-verzoeken: "Could not complete cart operation.
           The cart conflicted with another request." 429 komt van de
           botdetectie, die aanslaat op herhaalde identieke verzoeken. In beide
           gevallen is even wachten de juiste reactie; meteen opnieuw rammen
           maakt het erger. */
        if (r.status === 409 || r.status === 429) {
          var fout = new Error('wagen bezet (' + r.status + ')');
          fout.wachten = true;
          throw fout;
        }
        /* De reden NIET weggooien. Shopify zet bij een 4xx een leesbare uitleg
           in het antwoord ("sold out", "selling plan not available", "variant
           does not exist"), en die stond nergens: de knop zei alleen "something
           went wrong" en wie het onderzocht moest gaan raden. Nu komt de status
           plus die uitleg in de console te staan, en in de fout zelf. */
        if (!r.ok) {
          return r.text().then(function (ruw) {
            var uitleg = ruw;
            try { var j = JSON.parse(ruw); uitleg = j.description || j.message || ruw; } catch (e) {}
            throw new Error('add ' + r.status + ': ' + String(uitleg).slice(0, 300));
          });
        }
        return r.json();
      }).then(function (antwoord) {
        return { antwoord: antwoord };
      });
    });
  }

  /* KOPEN EN DOORGAAN NAAR DE KASSA, in een keten die beide koopknoppen delen:
     die van de productpagina en die van de kaarten op de homepage. Hij vult de
     wagen, leest na of er ECHT in ligt wat er gekozen is, en probeert het bij
     een botsing een keer opnieuw.

     Waarom nalezen: tussen legen en vullen is de wagen even leeg, en er
     schrijven meer partijen naar dezelfde wagen (een heatmap, een trackingapp).
     Zonder deze controle kan iemand op een afrekening zonder regels belanden.
     Levert hij false, dan gaat de beller naar /cart in plaats van de kassa:
     daar ziet de klant tenminste wat er wel of niet ligt. */
  /* ── de weg naar de kassa, met de korting van de aanbieding erbij ─────────
     De aanbieding rekent met de volle prijs in het verkoopplan, en het verschil
     komt als korting op de bestelling te staan. Alleen zo laat de kassa zien wat
     de klant bespaart: eerst $90,00, dan de korting, dan $49,00. Zat dat verschil
     in de planprijs, dan stond er alleen een eindbedrag.

     WIE BESLIST WAT. De lade (sections/cart-drawer-v1.liquid) draagt het hele
     contract: welk verkoopplan bij welke code hoort, vanaf welk bedrag die code
     mag, en het zetten zelf. Zij hangt op élke pagina en doet dit ook bij elke
     paginalading, dus de code staat al op de wagen voordat hier iemand op kopen
     drukt. Deze aanroep is de zekerheid dat hij er staat op het moment dat het
     telt: tussen vullen en doorsturen zit geen paginalading.

     Lukt het niet, of kent de lade de functie niet, dan gaat de bezoeker gewoon
     naar de kassa. Een korting missen is vervelend, de kassa missen is erger. */
  function afrekenPad() {
    var lade = window.cartDrawerV1;
    if (!lade || typeof lade.applyOfferDiscount !== 'function') return Promise.resolve(pad('checkout'));
    return Promise.resolve(lade.applyOfferDiscount())
      .then(function (wagen) {
        var code = lade.offerDiscountCode(wagen);
        if (!code) return pad('checkout');
        return pad('discount/' + encodeURIComponent(code)) + '?redirect=' + encodeURIComponent(pad('checkout'));
      })
      .catch(function () { return pad('checkout'); });
  }

  function koopKeten(m, keuze, regels, nog) {
    return zetWagen(m, keuze).catch(function (e) {
      if (!e || !e.wachten || nog <= 0) throw e;
      return new Promise(function (r) { setTimeout(r, 900); }).then(function () {
        nog = 0;
        return zetWagen(m, keuze);
      });
    }).then(function (res) {
      /* Het antwoord van add.js bevat de regels die er zojuist in zijn gelegd,
         met id, aantal en verkoopplan. Klopt dat, dan hoeft cart.js niet apart
         opgehaald te worden en scheelt dat een volledige retour. */
      if (res && res.antwoord && wagenKloptMet(regels, res.antwoord)) return true;
      return leesWagen().then(function (wagen) {
        if (wagenKloptMet(regels, wagen)) return true;
        if (nog <= 0) return false;
        return koopKeten(m, keuze, regels, nog - 1);
      });
    });
  }

  if (modules.length) {
    var eerst = modules[0];
    staat = {
      flavor: eerst.getAttribute('data-flavor') || 'o',
      qty: Number(eerst.getAttribute('data-qty') || 60),
      mode: 'sub',
    };

    modules.forEach(function (m) {
      m.addEventListener('click', function (e) {
        var fl = e.target.closest('[data-v14-flavor]');
        var qt = e.target.closest('[data-v14-qty]');
        var md = e.target.closest('[data-v14-mode]');
        if (fl) {
          var f = fl.getAttribute('data-v14-flavor');
          staat.flavor = f;
          if (f === 'm') staat.qty = 60;      /* Both dwingt 60 af */
          teken();
        } else if (qt) {
          var n = Number(qt.getAttribute('data-v14-qty'));
          /* 30 kiezen terwijl Both aanstaat zet de smaak terug op Original */
          if (n === 30 && staat.flavor === 'm') staat.flavor = 'o';
          staat.qty = n;
          teken();
        } else if (md) {
          staat.mode = md.getAttribute('data-v14-mode');
          teken();
        }
      });

      /* ── PUNT 4.3: pijltoetsen binnen een radiogroep ───────────────────────
         In een radiogroep verplaatsen de pijlen de focus én de keuze, en ze
         lopen rond. Home en End springen naar de eerste en de laatste.

         preventDefault is hier geen smaakkwestie: zonder dat scrolt ArrowDown de
         pagina 40px omlaag — gemeten op 1440 en op 390 — terwijl de knop die net
         gekozen werd juist in beeld moet blijven.

         De keuze zelf gaat via .click() op de doelknop, dus precies door de
         handler hierboven. Zo blijven de twee uitzonderingen ("Both" dwingt 60
         af, 30 zet de smaak terug op Original) op één plek staan en kan het
         toetsenbordpad niet uit de pas lopen met de muis. Gemeten: dezelfde
         reeks keuzes met de muis en met de pijlen geeft dezelfde staat.

         Hidden valt uit de ronde: bij 30 servings bestaat de kaart "Both" niet,
         dus de smaakgroep loopt dan rond over twee kaarten.

         De luisteraar staat binnen modules.forEach en zoekt de groep binnen de
         aangeslagen knop, dus het bovenste en het onderste koopblok zitten
         elkaar niet in de weg. */
      m.addEventListener('keydown', function (e) {
        var r = e.target.closest('[role="radio"]');
        if (!r) return;
        var groep = r.closest('[role="radiogroup"]');
        if (!groep) return;
        var rs = alle('[role="radio"]', groep).filter(function (b) { return !b.hidden; });
        var i = rs.indexOf(r), n = rs.length, j;
        if (i < 0) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i + n - 1) % n;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = n - 1;
        else return;
        e.preventDefault();
        rs[j].click();
        /* focus() zonder preventScroll: de keuze verandert de hoogte van de
           kaarten, en dan moet de knop die de focus krijgt in beeld worden
           gebracht. Met preventScroll stond hij op 1440 buiten beeld. */
        rs[j].focus();
      });
    });

    /* ── kopen ───────────────────────────────────────────────────────────────
       Model A uit SHOPIFY-TODO §3.4: twee betaalde regels bij 60 servings, dus
       geen gratis-tweede-pouch-variant. Bij Both één regel per smaak.
       De cadeaus gaan als eigen regels mee, en alleen bij een abonnement. */

    /* PUNT 1.2 EN DE TWEEDE KOOPKNOP. De grendel was aria-busy op de
       aangeklikte knop, en de CSS maakt daar pointer-events:none van. Dat houdt
       de muis tegen maar niet het toetsenbord: gemeten gaf tweemaal Enter vier
       POSTs naar /cart/add.js en een wagen met 4 pouches, 2 scoops en 2 cups in
       plaats van 2, 1 en 1; Enter vasthouden gaf er vijf. En omdat het attribuut
       per knop staat terwijl deze module TWEE keer op de pagina staat, bleef de
       tweede koopknop bruikbaar terwijl de eerste nog liep — twee ketens die door
       elkaar heen in dezelfde wagen schrijven, laatste schrijver wint.

       Eén vlag voor beide knoppen lost allebei op. Niet knop.disabled: zodra de
       gefocuste knop uitgeschakeld wordt springt de focus naar <body> en is de
       toetsenbordgebruiker zijn plek kwijt (gemeten). */
    var bezigMetKopen = false;

    /* TERUG VAN DE KASSA MET DE TERUGKNOP.
       Chrome zet deze pagina bevroren terug (bfcache): geen nieuwe lading, geen
       script dat opnieuw begint, alles staat er nog precies zo bij als toen de
       bezoeker wegsprong. De grendel hierboven stond dus nog op true en het
       label nog op "Adding…", en daarmee deed de koopknop niets meer tot iemand
       ververste. Gemeld door een klant op 13 oktober 2026.

       pageshow met persisted is het enige moment waarop je zo'n terugkeer kunt
       zien; load en DOMContentLoaded komen dan niet. teken() zet de labels terug
       zoals ze bij de huidige keuze horen, dus er hoeft hier niets te raden. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      bezigMetKopen = false;
      alle('[data-v14-add]').forEach(function (k) { k.removeAttribute('aria-busy'); });
      teken();
    });

    alle('[data-v14-add]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        if (bezigMetKopen) return;
        bezigMetKopen = true;
        /* DE KNOP ONDER DE GALERIJ STAAT BUITEN EEN OFFER-MODULE. Hij draagt wel
           data-v14-add, zodat hij deze hele keten erft in plaats van er een
           tweede van te krijgen: dezelfde grendel, dezelfde aria-busy, dezelfde
           foutafhandeling. closest() geeft voor hem null, en dan is de eerste
           module de juiste bron: de keuze wordt toch tussen alle modules
           gespiegeld, dus ze dragen allemaal dezelfde staat. */
        var m = knop.closest('[data-v14-offer]') || document.querySelector('[data-v14-offer]');

        /* De wagen eerst legen. Dit is een landingspagina met één aanbod: zonder
           legen stapelt een tweede klik, of een terugkeer na de checkout, de
           aantallen op en bestelt iemand het dubbele. Gemeten: twee keer dezelfde
           regel toevoegen gaf qty 2 in plaats van een vervanging. Uit te zetten
           per koopblok met de instelling. */
        knop.setAttribute('aria-busy', 'true');
        /* De knop zei tot nu toe alleen "ik sta op 70% doorzichtig" terwijl er
           vier verzoeken achter elkaar lopen. Het label vertelt nu wat er gebeurt;
           teken() zet het bij de eerstvolgende keuzewijziging vanzelf terug. */
        var ctaLbl = knop.querySelector('[data-v14-ctalabel]');
        if (ctaLbl) ctaLbl.textContent = 'Adding…';
        var regels = regelsVoorKeuze(m);

        /* Nalezen vóór we doorsturen. Dezelfde race die de express-rij trof kan
           ook deze knop treffen: de regels belanden dan in een andere wagen dan
           waar de browser naar wijst, en de klant komt op een afrekening zonder
           regels terecht — en vandaar op de homepage. Eén keer opnieuw proberen,
           en lukt het dan nog niet, dan naar /cart in plaats van naar de kassa.
           Daar ziet de klant tenminste wat er wel of niet in ligt. */
        /* De keten staat nu bij zetWagen, want de kaarten op de homepage
           doorlopen hem ook. Hier verandert er niets aan het gedrag. */
        koopKeten(m, null, regels, 1).then(function (goed) {
          if (!goed) { window.location.href = pad('cart'); return; }
          return afrekenPad().then(function (bestemming) { window.location.href = bestemming; });
        }).catch(function (err) {
          /* Zichtbaar voor wie de pagina onderzoekt; de bezoeker ziet alleen het
             vriendelijke label hieronder. */
          try {
            console.error('[upgrd-v14] kopen mislukt:', (err && err.message) || err,
                          '\n  keuze:', JSON.stringify(staat),
                          '\n  regels:', JSON.stringify(regels));
          } catch (e) {}
          /* PUNT 1.3: NIET doorsturen als het toevoegen zelf faalde. De wagen is
             dan al geleegd (zie zetWagen hierboven: clear gaat vóór add), dus een
             sprong naar /cart zette de bezoeker op een lege wagen zonder één woord
             uitleg — gemeten bij 422 "sold out", bij een netwerkfout en bij 409,
             telkens binnen 4ms en met een wagen die daarvoor nog gevuld was. En
             add.js is atomair, dus één uitverkochte cadeauregel laat élke aankoop
             zo stranden. Beter op de pagina blijven, het zeggen, en de knop
             teruggeven zodat hij het opnieuw kan proberen. */
          bezigMetKopen = false;
          knop.removeAttribute('aria-busy');
          var lbl = knop.querySelector('[data-v14-ctalabel]');
          if (lbl) lbl.textContent = 'Something went wrong, tap to try again';
        });
      });
    });

    /* ── de portemonneeknoppen laten kloppen ──────────────────────────────
       Dit zijn Shopify's eigen knoppen en ze rekenen de WINKELWAGEN af, niet
       wat er op de pagina aangeklikt staat. Ze kunnen dus alleen het juiste doen
       als de wagen meeloopt met de keuze. Daarom:

         1. bij elke wijziging de wagen opnieuw zetten, met een rustpauze zodat
            drie klikken achter elkaar niet drie keer de wagen herschrijven;
         2. daarna de sectie opnieuw ophalen via de Section Rendering API en de
            knoppenrij vervangen. Shopify hertekent deze knoppen namelijk alleen
            als de sectie waar ze in staan opnieuw wordt opgevraagd; zonder die
            stap blijven ze op de oude wagen staan.

       Zolang de wagen nog niet gelijk is, staat de rij op aria-busy en vangen we
       de klik op: anders opent iemand een betaalscherm met de vorige keuze erin.
       Dat is het soort fout dat geld kost, dus hij mag liever even wachten. */
    teken();
  }

  /* ── galerij ──────────────────────────────────────────────────────────────
     EIGEN BEREIK, EN DAT IS GEEN NETHEID.
     var is functie-gebonden, niet blok-gebonden. Deze blokken staan allemaal in
     dezelfde IIFE, en de keurmerken-slider hieronder declareert óók `var spoor`
     en `var n`. Die liepen dus over elkaar heen: na het laden wees `spoor` naar
     het keurmerkenspoor, en een klik op een duimnagel of een pijl van de galerij
     scrollde de keurmerken in plaats van de beelden. Gemeten: de klik riep
     scrollTo aan op .v14-seals__spoor. */
  (function () {
  var gal = document.querySelector('[data-v14-gal]');
  if (gal) {
    var spoor = gal.querySelector('[data-v14-track]');
    /* Het aantal dia's ligt niet vast. De dia die laat zien wat er in de doos
       zit staat er alleen bij 60 servings, dus hij wordt geteld op het moment
       dat het nodig is in plaats van één keer bij het laden. Zonder dat liep de
       pijl na de laatste dia door naar een beeld dat er niet meer was. */
    var aantal = function () {
      return alle('[data-v14-slide]', gal).filter(function (d) { return !d.hidden; }).length;
    };

    var naarBeeld = function (i, zacht) {
      if (!spoor) return;
      var m = aantal();
      if (!m) return;
      var k = (i + m) % m;
      spoor.scrollTo({ left: k * spoor.clientWidth, behavior: zacht === false ? 'auto' : 'smooth' });
    };
    /* DE RAIL MAG NIET ELKE FRAME EEN NIEUWE ANIMATIE KRIJGEN.
       Gemeten op 390px met echt scrollgedrag, voor deze twee regels bestonden:
       34 scroll-events op het spoor, 3 tot 6 per dia, en 22 scrollBy-aanroepen
       op de duimnagelrail, elke 15 tot 18ms oftewel elk beeldframe. Een
       vloeiende scroll duurt in Chrome 250 tot 300ms, dus elke aanroep brak de
       vorige af voordat die een pixel had afgelegd. De gevraagde afstand liep
       daardoor op van 50 naar 313px -- drie identieke deltas achter elkaar
       (313, 313, 311) laten zien dat de rail tussen die frames stilstond. Als
       je dan stopt met vegen schiet hij die hele afstand in een keer door, en
       dat is het schokkerige en trage gevoel. Het viel het meest op bij de
       laatste duimnagel, want daar is de opgelopen achterstand het grootst.

       Twee grendels, allebei nodig:

       EEN. Niets doen als de dia niet veranderd is. Dat haalt de 34 events
       terug naar een handeling per dia.

       TWEE. Verandert de dia binnen 300ms na de vorige, dan veegt de bezoeker
       door en zou een vloeiende scroll toch weer afgebroken worden. Dan volgt
       de rail direct. Alleen na een rustpauze is er tijd voor de animatie, en
       dat is precies het geval waarin hij nu al goed voelde: een losse stap. */
    var merkIndex = -1, merkTijd = 0;
    var merk = function (i) {
      if (i === merkIndex) return;
      var nu = (window.performance && performance.now) ? performance.now() : Date.now();
      var achtereen = merkIndex !== -1 && (nu - merkTijd) < 300;
      merkIndex = i;
      merkTijd = nu;
      alle('[data-v14-thumb]', document).forEach(function (t) {
        var aan = Number(t.getAttribute('data-v14-thumb')) === i;
        t.setAttribute('aria-current', aan ? 'true' : 'false');
        /* De duimnagel die aan de beurt is ook in beeld brengen. Zonder dit
           bleef de rail staan waar hij stond: vanaf slide 5 stond de gekozen
           duimnagel 136 tot 480px buiten de rail, en dan is er geen enkele
           oranje rand te zien terwijl de bezoeker wel door de beelden bladert.
           Maar NIET met scrollIntoView. Die schuift ELKE scrollbare voorouder
           mee, de pagina incluis. Kiest de bezoeker onderin het laatste
           koopblok een andere smaak, dan zet teken() het spoor terug op beeld 1
           (:205), vuurt dat de scroll-luisteraar hieronder af, en sleurde
           scrollIntoView de hele pagina mee omhoog naar de galerij. Gemeten, na
           doorbladeren in de galerij: 1440px scrollY 8353 -> 1505 (-6848),
           1024px 9049 -> 1856 (-7193), 768px 9586 -> 711 (-8875), 390px
           9136 -> 525 (-8611), 320px 9781 -> 470 (-9311). Bij smaak, bij aantal
           EN bij plan, want alle drie lopen via teken(). Zonder doorbladeren
           staat het spoor al op 0, komt er geen scroll-event, en gebeurde er
           niets — dat is waarom dit zo lang onzichtbaar bleef.

           Dus de 'nearest'-rekensom hier zelf, op de rail en op niets anders:
           schuif het kleinste stuk dat nodig is om de duimnagel binnen het
           scrollvenster van zijn eigen rail te krijgen, en niets als hij er al
           in valt — dus de rail springt nog steeds niet bij elke stap. Beide
           assen blijven nodig: vanaf 1024px is de rail verticaal, eronder
           horizontaal. De rail van de andere breedte staat op display:none,
           geeft een nul-rect, en blijft daardoor vanzelf staan. */
        if (aan) {
          var rail = t.parentElement;
          if (rail) {
            var vak = t.getBoundingClientRect(), venster = rail.getBoundingClientRect();
            var dx = vak.left < venster.left ? vak.left - venster.left
                   : (vak.right > venster.right ? vak.right - venster.right : 0);
            var dy = vak.top < venster.top ? vak.top - venster.top
                   : (vak.bottom > venster.bottom ? vak.bottom - venster.bottom : 0);
            if (dx || dy) rail.scrollBy({ left: dx, top: dy,
              behavior: (rustig || achtereen) ? 'auto' : 'smooth' });
          }
        }
      });
    };
    if (spoor) {
      spoor.addEventListener('scroll', function () {
        var i = Math.round(spoor.scrollLeft / Math.max(1, spoor.clientWidth));
        merk(i);
      }, { passive: true });
    }
    alle('[data-v14-thumb]', document).forEach(function (t) {
      t.addEventListener('click', function () { naarBeeld(Number(t.getAttribute('data-v14-thumb'))); });
    });
    var huidig = function () { return spoor ? Math.round(spoor.scrollLeft / Math.max(1, spoor.clientWidth)) : 0; };
    var vorige = gal.querySelector('[data-v14-prev]');
    var volgende = gal.querySelector('[data-v14-next]');
    if (vorige) vorige.addEventListener('click', function () { naarBeeld(huidig() - 1); });
    if (volgende) volgende.addEventListener('click', function () { naarBeeld(huidig() + 1); });
    /* De indexgrendel hierboven laat merk() niets doen zolang de dia gelijk
       blijft, en dat is precies wat we willen -- behalve bij een breedtewissel.
       Vanaf 1024px is de rail verticaal en eronder horizontaal, dus na een
       draai of een venstersprong is de andere rail zichtbaar en staat die op
       nul, met de actieve duimnagel mogelijk buiten beeld. Zonder deze regel
       corrigeert hij pas bij de volgende dia. De grendel gaat dus open en de
       rail wordt eenmalig opnieuw gezet. */
    window.addEventListener('resize', function () { merkIndex = -1; merk(huidig()); });
    merk(0);
  }
  })();

  /* ── accordions: grid-template-rows 0fr → 1fr ────────────────────────────── */
  alle('[data-v14-acc]').forEach(function (acc) {
    var knop = acc.querySelector('[data-v14-acctoggle]');
    if (!knop) return;
    knop.addEventListener('click', function () {
      var open = acc.getAttribute('data-open') === 'true';
      acc.setAttribute('data-open', open ? 'false' : 'true');
      knop.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });

  /* ── mobiele koopbalk: zichtbaar na het hero-koopblok, weg bij het laatste ── */
  var balk = document.querySelector('[data-v14-buybar]');
  if (balk && 'IntersectionObserver' in window) {
    /* PUNT 24 — de voet kwam erbij. De balk staat nu ook op desktop, en een
       vaste balk van 77px legt anders de hele onderste rij van de voet onder
       zich: daar staan de aanmelding voor de lijst en de links. De referentie
       doet hetzelfde en haalt zijn balk ~300px voor het einde weg. */
    var voet = document.querySelector('.v14-ftr');
    var zicht = { hero: true, final: false, voet: false, voorbij: false };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var k = (e.target === voet) ? 'voet' : e.target.getAttribute('data-plek');
        if (!k) return;
        zicht[k] = e.isIntersecting;
        if (k === 'hero') zicht.voorbij = !e.isIntersecting && e.boundingClientRect.top < 0;
      });
      var aan = zicht.voorbij && !zicht.hero && !zicht.final && !zicht.voet;
      balk.setAttribute('data-on', aan ? 'true' : 'false');
    });
    modules.forEach(function (m) { io.observe(m); });
    if (voet) io.observe(voet);
  }


  /* ── ingredientenpaneel ───────────────────────────────────────────────────
     Eén paneel in de DOM; de inhoud komt uit de aangeklikte tegel. Mobiel een
     bottom sheet, desktop een zijpaneel — dat verschil zit volledig in tokens,
     dus hier alleen openen, sluiten, de veeg naar beneden en de scrollgrendel. */
  var laag = document.querySelector('[data-v14-sheetlaag]');
  var sheet = laag && laag.querySelector('[data-v14-sheet]');
  if (laag && sheet) {
    var tegels = alle('[data-v14-ing]');
    var inhoud = tegels.map(function (t) {
      return {
        naam: t.getAttribute('data-naam') || '',
        tekst: t.getAttribute('data-tekst') || '',
        apart: t.getAttribute('data-apart') || '',
        waarde: t.getAttribute('data-waarde') || '',
        waardelabel: t.getAttribute('data-waardelabel') || '',
        foto: t.getAttribute('data-foto') || '',
        fotoalt: t.getAttribute('data-fotoalt') || '',
        ben: (t.getAttribute('data-ben') || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean),
      };
    });
    var open = null, startY = null;
    /* PUNT 4.2: de tegel die het paneel opende, zodat de focus daar bij sluiten
       weer terechtkomt in plaats van op <body> te blijven liggen. */
    var opener = null;
    var zetS = function (sel, v) { var el = sheet.querySelector(sel); if (el) el.textContent = v; };

    function toon(i) {
      open = i;
      var d = inhoud[i] || {};
      /* Punt 15 haalde de nummering en de waardebadge uit het paneel. Het blok
         "What sets ours apart" staat er sinds 12 okt 2026 weer in, op verzoek
         van de klant; zie de sectie voor de afweging. */
      zetS('[data-v14-sheettitle]', d.naam);
      zetS('[data-v14-sheettext]', d.tekst);

      /* Geen tekst bij dit ingredient betekent ook geen kop. Het blok staat
         daarom verborgen in de markup en komt alleen tevoorschijn als er iets
         in te zetten valt. */
      var apartBlok = sheet.querySelector('[data-v14-sheetapartblok]');
      if (apartBlok) {
        zetS('[data-v14-sheetapart]', d.apart);
        apartBlok.hidden = !d.apart;
      }

      var foto = sheet.querySelector('[data-v14-sheetfoto]');
      if (foto) {
        foto.setAttribute('aria-label', d.fotoalt);
        foto.textContent = d.foto ? '' : d.fotoalt;   /* plaatshouder tot de foto er is */
        foto.style.backgroundImage = d.foto ? 'url(' + d.foto + ')' : '';
      }

      var ul = sheet.querySelector('[data-v14-sheetben]');
      if (ul) {
        ul.innerHTML = '';
        d.ben.forEach(function (b) {
          var li = document.createElement('li');
          li.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5 L10 17 L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          li.appendChild(document.createTextNode(b));
          ul.appendChild(li);
        });
      }

      laag.setAttribute('data-on', 'true');
      laag.setAttribute('aria-hidden', 'false');
      tegels.forEach(function (t, j) { t.setAttribute('aria-expanded', j === i ? 'true' : 'false'); });
      grendel('paneel', true);

      /* PUNT 4.2: de focus naar binnen. De sluitknop is de eerste tabstop in het
         paneel en de enige die er altijd is, dus daar landt hij. Dit moet NA het
         zetten van data-on staan: punt 4.1 maakt de laag pas op dat moment
         zichtbaar, en focus() op iets met visibility:hidden doet niets.
         Gemeten: in de omgekeerde volgorde blijft de focus op de tegel staan. */
      opener = tegels[i] || null;
      var kruis = sheet.querySelector('[data-v14-sheetclose]');
      if (kruis) kruis.focus();
    }
    /* naarOpener is alleen false als de klik zélf al een bestemming heeft: de
       Shop-knop in de voet is een anker naar #top. De luisteraars die `dicht`
       rechtstreeks doorgeven sturen hun event mee, en een event is niet false,
       dus die herstellen de focus wél — net als Escape, dat zonder argument
       aanroept. */
    function dicht(naarOpener) {
      open = null;
      laag.setAttribute('data-on', 'false');
      laag.setAttribute('aria-hidden', 'true');
      sheet.style.transform = '';
      tegels.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      grendel('paneel', false);
      /* De tegel staat buiten het paneel, dus hij schuift niet mee weg in de
         0,45s die het dichtschuiven kost. */
      if (naarOpener !== false && opener) opener.focus();
      opener = null;
    }

    /* Een tweede klik op dezelfde tegel sluit het paneel weer. Dat ging eerst
       mis: de tegel riep altijd toon() aan, en omdat de overlay er dan al
       overheen ligt kwam je er alleen nog uit via het kruisje. Een plusteken dat
       open klapt hoort met dezelfde klik ook weer dicht te gaan. */
    tegels.forEach(function (t, i) {
      t.addEventListener('click', function () { if (open === i) dicht(); else toon(i); });
    });
    var sluit = sheet.querySelector('[data-v14-sheetclose]');
    if (sluit) sluit.addEventListener('click', dicht);
    var ov = laag.querySelector('[data-v14-sheetov]');
    if (ov) ov.addEventListener('click', dicht);
    var shop = sheet.querySelector('[data-v14-sheetshop]');
    /* De Shop-knop is <a href="#top">: die stuurt de bezoeker zelf al ergens
       heen, dus hier géén focusherstel (PUNT 4.2). */
    if (shop) shop.addEventListener('click', function () { dicht(false); });
    window.addEventListener('keydown', function (e) {
      if (open == null) return;
      if (e.key === 'Escape') dicht();
      klem(sheet, e);                                /* PUNT 4.2: Tab blijft binnen */
    });

    /* veeg naar beneden sluit, maar alleen als de inhoud al bovenaan staat */
    sheet.addEventListener('touchstart', function (e) {
      var sc = sheet.querySelector('[data-v14-sheetscroll]');
      startY = (sc && sc.scrollTop > 0 && !e.target.closest('[data-v14-sheethead]')) ? null : e.touches[0].clientY;
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (startY == null || window.matchMedia('(min-width: 1024px)').matches) return;
      var dd = Math.max(0, e.touches[0].clientY - startY);
      sheet.style.transition = 'none';
      sheet.style.transform = 'translateY(' + dd + 'px)';
      sheet.__d = dd;
    }, { passive: true });
    sheet.addEventListener('touchend', function () {
      sheet.style.transition = '';
      var dd = sheet.__d || 0; sheet.__d = 0; startY = null;
      if (dd > 110) dicht(); else sheet.style.transform = '';
    });
  }

  /* ── keurmerken-slider, alleen onder 768px ────────────────────────────────
     Eén per keer, elke 3,2s door, 0,8s overgang, oneindig via een kloon van het
     eerste item. Na een veeg of een tik op een bolletje acht seconden pauze. */
  var seals = document.querySelector('[data-v14-seals]');
  if (seals && !rustig) {
    var spoor = seals.querySelector('[data-v14-sealtrack]');
    var dots = alle('[data-v14-sealdot]', seals);
    var n = dots.length;
    var i = 0, pauzeTot = 0, sleepX = null;

    function sealTeken(anim) {
      if (!spoor) return;
      spoor.setAttribute('data-anim', anim ? 'true' : 'false');
      spoor.style.setProperty('--sealX', '-' + (i * 100) + '%');
      dots.forEach(function (d, j) { d.setAttribute('aria-current', j === (i % n) ? 'true' : 'false'); });
    }
    setInterval(function () {
      if (document.hidden || Date.now() < pauzeTot) return;
      if (window.matchMedia('(min-width: 768px)').matches) return;
      if (i >= n) { i = 0; sealTeken(false); return; }   /* kloon bereikt: zonder animatie terug */
      i += 1; sealTeken(true);
    }, 3200);
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () { i = j; pauzeTot = Date.now() + 8000; sealTeken(true); });
    });

    /* De twee pijlen naast de bolletjes. Ze lopen ROND en gaan niet uit aan het
       eind, anders dan bij de veegrijen: deze carrousel draait vanzelf door, en
       een pijl die uitgeschakeld lijkt terwijl de rij een tel later toch verder
       schuift leest verkeerd. i kan op dat moment op de kloon staan (i === n),
       dus eerst terugrekenen naar het echte bereik. */
    alle('[data-v14-sealnav]', seals).forEach(function (knop) {
      knop.addEventListener('click', function () {
        var richting = parseInt(knop.getAttribute('data-v14-sealnav'), 10) || 1;
        pauzeTot = Date.now() + 8000;
        i = ((i % n) + richting + n) % n;
        sealTeken(true);
      });
    });
    if (spoor) {
      spoor.addEventListener('touchstart', function (e) { sleepX = e.touches[0].clientX; }, { passive: true });
      spoor.addEventListener('touchend', function (e) {
        if (sleepX == null) return;
        var d = e.changedTouches[0].clientX - sleepX; sleepX = null;
        if (Math.abs(d) < 40) return;                     /* drempel uit de bron */
        pauzeTot = Date.now() + 8000;
        i = Math.max(0, Math.min(n - 1, i + (d < 0 ? 1 : -1)));
        sealTeken(true);
      });
    }
    sealTeken(false);
  }


  /* ── bolletjes onder de veegrijen (stappen, voordelen) ────────────────────
     Eén afhandeling voor beide rijen: de rij draagt data-v14-rij="<naam>" en de
     bolletjes data-v14-dots="<naam>". De index volgt uit de scrollpositie
     gedeeld door de breedte van het eerste kind plus de kolomgap. Helemaal rechts
     wint het laatste kind, anders blijft de laatste stap onbereikbaar als hij
     smaller is dan de rest. */
  /* EEN STAP IS EEN KAART, voor elke rij en voor beide soorten pijlen: de
     breedte van het eerste kind plus de kolomgap, dezelfde som waarmee de
     bolletjes hieronder de index bepalen. Aan het begin en het eind gaat de knop
     op disabled; hij blijft staan, want een knop die verdwijnt verschuift de
     bolletjes ernaast, maar hij vervaagt en doet niets.

     Deze functie bedient zowel de pijlen bij de bolletjes (data-v14-rijnav, op
     een telefoon) als de twee pijlen die op desktop over de videorij liggen
     (data-v14-vidnav). Dat was eerst twee keer dezelfde code op twee plekken. */
  /* DE STAP VAN EEN RIJ IS DE AFSTAND TUSSEN TWEE KAARTEN, en die is niet
     hetzelfde als de breedte van een kaart. Op een telefoon zijn de videotegels
     smaller dan hun baan en staan ze daar gecentreerd in: de kaart is 272 breed
     terwijl de rij per stap 370 opschuift. Met de kaartbreedte kwam de stap op
     292 uit, schoof de pijl te weinig, trok de snap het verschil er weer bij, en
     sprongen de bolletjes een nummer door. De linkerranden van twee kinderen
     zeggen het zonder aannames. */
  var stapVan = function (rij) {
    var k = rij.children;
    if (k.length > 1) {
      var d = k[1].offsetLeft - k[0].offsetLeft;
      if (d > 0) return d;
    }
    return k[0] ? k[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(rij).columnGap) || 0) : 1;
  };

  var schuifKnoppen = function (rij, vorig, volgend) {
    if (!vorig && !volgend) return;
    var merk = function () {
      var max = rij.scrollWidth - rij.clientWidth;
      if (vorig) vorig.disabled = rij.scrollLeft <= 2;
      if (volgend) volgend.disabled = rij.scrollLeft >= max - 2;
    };
    var schuif = function (richting) {
      rij.scrollBy({ left: stapVan(rij) * richting, behavior: 'smooth' });
    };
    if (vorig) vorig.addEventListener('click', function () { schuif(-1); });
    if (volgend) volgend.addEventListener('click', function () { schuif(1); });
    rij.addEventListener('scroll', merk, { passive: true });
    window.addEventListener('resize', merk);
    merk();
  };

  alle('[data-v14-rij]').forEach(function (rij) {
    var naam = rij.getAttribute('data-v14-rij');
    var balk = document.querySelector('[data-v14-dots="' + naam + '"]');
    if (!balk) return;
    var knoppen = alle('[data-v14-dot]', balk);

    /* De twee pijlen staan in dezelfde balk als de bolletjes en horen bij deze
       rij; upgrd-v14-dotrij.liquid zet ze daar neer. */
    schuifKnoppen(rij, balk.querySelector('[data-v14-rijnav="-1"]'), balk.querySelector('[data-v14-rijnav="1"]'));

    /* BOLLETJES ALLEEN ALS ER IETS TE SCHUIVEN VALT. Het omslagpunt waarop een
       rij past verschilt per rij: de kaartenrail van de homepage past eerder
       dan de videotegels, en die weer eerder dan de vijf tegels op de
       productpagina. Dat in mediaqueries bijhouden betekent dezelfde maat op
       twee plekken, en die lopen uit elkaar. Dus meten.

       De balk draagt display uit --rowDots, en [hidden] verliest dat van een
       klassenregel; .v14-dotrij[hidden] in het blad maakt het alsnog hard. */
    var merkNut = function () {
      balk.hidden = rij.scrollWidth <= rij.clientWidth + 4;
    };
    window.addEventListener('resize', merkNut);
    merkNut();

    var merkRij = function (i) {
      knoppen.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    };
    rij.addEventListener('scroll', function () {
      if (!rij.firstElementChild) return;
      var i = Math.round(rij.scrollLeft / Math.max(1, stapVan(rij)));
      if (rij.scrollLeft + rij.clientWidth >= rij.scrollWidth - 4) i = rij.children.length - 1;
      merkRij(Math.max(0, Math.min(knoppen.length - 1, i)));
    }, { passive: true });
    knoppen.forEach(function (b, j) {
      b.addEventListener('click', function () {
        var kind = rij.children[j];
        if (kind) rij.scrollTo({ left: kind.offsetLeft - rij.firstElementChild.offsetLeft, behavior: 'smooth' });
      });
    });
  });


  /* ── PUNT 19: schuifpijlen bij de videorij ────────────────────────────────
     Eén stap is één kaart: de breedte van het eerste kind plus de kolomgap,
     net als de bolletjes hieronder rekenen. Aan het begin en het eind vallen de
     pijlen weg in plaats van uitgegrijsd te blijven staan; de referentie laat ze
     daar oneindig doordraaien, maar die heeft geen bolletjes op desktop en wij
     wel, en een rij die stiekem terugspringt naar het begin leest verkeerd. */
  alle('.v14-vids__wikkel').forEach(function (wikkel) {
    var rij = wikkel.querySelector('[data-v14-rij]');
    if (!rij) return;
    schuifKnoppen(rij, wikkel.querySelector('[data-v14-vidnav="-1"]'),
                       wikkel.querySelector('[data-v14-vidnav="1"]'));
  });


  /* ── lightbox: de rondjes in het koopblok openen de video groot ──────────── */
  var lb = document.querySelector('[data-v14-lightbox]');
  if (lb) {
    var lbVid = lb.querySelector('[data-v14-lbvideo]');
    var lbVorig = lb.querySelector('[data-v14-lbstap="-1"]');
    var lbVolgend = lb.querySelector('[data-v14-lbstap="1"]');
    /* De ketting is de groep waar de aangeklikte knop in zit: de vijf kaarten in
       sectie 07, of de vier rondjes in het koopblok. Zo blijft vorige/volgende
       binnen de rij waar de bezoeker vandaan kwam. */
    var keten = [];
    var ketenI = -1;
    /* PUNT 4.2: de knop die de lightbox opende. */
    var lbOpener = null;

    var lbDicht = function () {
      lb.setAttribute('data-on', 'false');
      if (lbVid) { lbVid.pause(); lbVid.removeAttribute('src'); lbVid.load(); }
      grendel('lightbox', false);
      setTimeout(function () { if (lb.getAttribute('data-on') === 'false') lb.hidden = true; }, 320);
      /* Hier en niet in die setTimeout: 320ms later zet punt 4.1 display:none op
         de lightbox, en dan is de focus al naar <body> gevallen. */
      if (lbOpener) { lbOpener.focus(); lbOpener = null; }
    };

    var lbZet = function (i) {
      if (!lbVid || !keten[i]) return;
      ketenI = i;
      lbVid.src = keten[i].getAttribute('data-v14-lb');
      lbVid.poster = keten[i].getAttribute('data-v14-lbposter') || '';
      if (lbVorig) lbVorig.disabled = i <= 0;
      if (lbVolgend) lbVolgend.disabled = i >= keten.length - 1;
      /* Met geluid proberen; weigert de browser dat, dan gedempt alsnog spelen,
         net als de kaarten zelf doen. De dempknop van de speler staat eronder,
         dus de bezoeker kan het terugzetten. */
      lbVid.muted = false;
      var pp = lbVid.play();
      if (pp && pp.catch) pp.catch(function () { lbVid.muted = true; lbVid.play().catch(function () {}); });
    };

    alle('[data-v14-lb]').forEach(function (knop) {
      knop.addEventListener('click', function () {
        if (!lbVid) return;
        var groep = knop.closest('[data-v14-lbgroep]');
        keten = groep ? alle('[data-v14-lb]', groep) : [knop];
        lb.hidden = false;
        requestAnimationFrame(function () { lb.setAttribute('data-on', 'true'); });
        grendel('lightbox', true);
        lbZet(keten.indexOf(knop));
        /* PUNT 4.2: opener onthouden en de focus naar binnen. De sluitknop is de
           enige knop in de lightbox die altijd bruikbaar is — de pijlen staan op
           de eerste en de laatste video op disabled. Dit mag hier synchroon,
           terwijl data-on nog 'false' is: punt 4.1 werkt met [hidden], en dat
           attribuut is drie regels hierboven al weg, dus de lightbox staat op
           display:grid. Gemeten: de focus landt op de sluitknop. */
        lbOpener = knop;
        var kruis = lb.querySelector('[data-v14-lbclose]');
        if (kruis) kruis.focus();
      });
    });

    [lbVorig, lbVolgend].forEach(function (knop) {
      if (!knop) return;
      knop.addEventListener('click', function () {
        lbZet(ketenI + (parseInt(knop.getAttribute('data-v14-lbstap'), 10) || 1));
      });
    });

    lb.addEventListener('click', function (e) { if (e.target === lb) lbDicht(); });
    var lbX = lb.querySelector('[data-v14-lbclose]');
    if (lbX) lbX.addEventListener('click', lbDicht);
    window.addEventListener('keydown', function (e) {
      if (lb.getAttribute('data-on') !== 'true') return;
      if (e.key === 'Escape') lbDicht();
      if (e.key === 'ArrowRight') lbZet(ketenI + 1);
      if (e.key === 'ArrowLeft') lbZet(ketenI - 1);
      klem(lb, e);                                   /* PUNT 4.2: Tab blijft binnen */
    });
  }

  /* ── video-reviews: een tegelijk ──────────────────────────────────────────
     Met geluid starten; weigert de browser dat, dan gedempt alsnog spelen, zoals
     toggleVid in de bron. Een andere video starten pauzeert de rest. */
  var vids = alle('[data-v14-vid]');
  vids.forEach(function (fig) {
    var el = fig.querySelector('video');
    var knop = fig.querySelector('[data-v14-vidtoggle]');
    if (!el || !knop) return;
    /* Het label klapt mee ZOLANG de tegel een pauzelabel meegeeft. De slider op
       de productpagina geeft er geen, dus die houdt zijn vaste "Play ..." en
       verandert niet. De tegelrij op de homepage geeft er een, zoals het
       klantontwerp. */
    var labelSpeel = knop.getAttribute('aria-label');
    var labelPauze = knop.getAttribute('data-v14-vidpauze');
    var merkVid = function () {
      fig.setAttribute('data-spelen', el.paused ? 'false' : 'true');
      knop.setAttribute('aria-pressed', el.paused ? 'false' : 'true');
      if (labelPauze) knop.setAttribute('aria-label', el.paused ? labelSpeel : labelPauze);
    };
    el.addEventListener('play', merkVid);
    el.addEventListener('pause', merkVid);
    knop.addEventListener('click', function () {
      vids.forEach(function (ander) {
        if (ander === fig) return;
        var v = ander.querySelector('video');
        if (v) v.pause();
      });
      if (el.paused) {
        el.muted = false;
        var p = el.play();
        if (p && p.catch) p.catch(function () { el.muted = true; el.play().catch(function () {}); });
      } else el.pause();
    });
  });


  /* ── Junip: de echte reviews ───────────────────────────────────────────────
     Endpoint en authenticatie zijn uitgeprobeerd tegen de echte API, niet
     overgenomen uit documentatie:

       GET https://api.juniphq.com/v1/product_reviews
       header  Junip-Store-Key: <sleutel>

     Alleen die header werkt; Authorization: Bearer en X-Junip-Store-Key geven
     allebei 401, en /v1/reviews bestaat niet. CORS staat open
     (access-control-allow-origin: *, en de preflight accepteert junip-store-key),
     dus dit mag vanuit de browser.

     Het gemiddelde komt NIET uit /v1/stores: dat geeft rating_count 0 omdat
     seller ratings uitstaan. Het wordt daarom uit de reviews zelf gerekend.

     ?include=customer hangt er een customer-object aan met first_name en
     last_name. Zonder die parameter komt er alleen een customer_id terug en
     staat er geen naam op de kaart. Gemeten: 38 van de 38 reviews hebben een
     voornaam, 37 een achternaam van precies één letter, dus "Mari K." valt
     samen met de vorm die het ontwerp toont. Oude notitie:
     /v1/customers is leeg en include=customer levert niets. Daarom staat er waar
     een naam hoort "Verified buyer" of niets, in plaats van een verzonnen naam.

     TWEE AFNEMERS, EEN AANVRAAG (11 okt 2026). De homepage toont de echte
     reviews nu op twee plekken: drie kaarten direct onder de video's
     ([data-v14-junip-top]) en de volledige lijst daaronder
     ([data-v14-junip-lijst]). Ze lezen dezelfde opgehaalde verzameling. Twee
     keer dezelfde URL halen kost niet alleen een tweede aanvraag; het kan ook
     twee verschillende volgordes opleveren, en dan staat dezelfde review boven
     en onder op de pagina met een andere buur. junipHaal() onthoudt de belofte,
     dus wie als tweede vraagt wacht op de eerste.

     EEN KAART WORDT OP EEN PLEK GEMAAKT. junipKaart() levert de markup voor
     allebei, zodat "precies dezelfde kaart als in de lijst" geen belofte is
     maar een gevolg. */
  var junipBelofte = null, junipCijfersGezet = false;

  function junipHaal(sleutel) {
    if (!junipBelofte) {
      junipBelofte = fetch('https://api.juniphq.com/v1/product_reviews?include=customer', {
        headers: { Accept: 'application/json', 'Junip-Store-Key': sleutel },
      }).then(function (r) {
        if (!r.ok) throw new Error('junip ' + r.status);
        return r.json();
      }).then(function (d) { return d.product_reviews || []; });
    }
    return junipBelofte;
  }

  /* "Mari" + "K" wordt "Mari K.", net als in het ontwerp. Junip levert de
     achternaam al als één letter; staat hij er niet, dan alleen de voornaam
     zonder losse punt. */
  function junipNaam(k) {
    var v = ((k && k.first_name) || '').trim();
    var a = ((k && k.last_name) || '').trim();
    if (!v) return 'Verified buyer';
    return a ? v + ' ' + a.charAt(0).toUpperCase() + '.' : v;
  }

  /* Een kommalijst uit een attribuut. Allebei de secties lezen hun overslaan-
     lijsten hiermee: zouden ze dat verschillend doen, dan tellen ze een ander
     aantal reviews en staan er twee getallen op dezelfde pagina. */
  function junipKommas(el, naam) {
    return (el.getAttribute(naam) || '').split(',').map(function (x) {
      return x.trim();
    }).filter(Boolean);
  }

  function junipVorm(ruw, negeer, negeerId) {
    var laag = negeer.map(function (x) { return x.toLowerCase(); });
    return ruw.filter(function (r) {
      if (negeerId.indexOf(String(r.id)) > -1) return false;
      var t = String(r.target_title || '').toLowerCase();
      return !laag.some(function (n) { return t.indexOf(n) > -1; });
    }).map(function (r) {
      return {
        id: String(r.id),
        titel: r.title || '',
        tekst: r.body || '',
        rating: Number(r.rating || 5),
        geverifieerd: !!r.verified_buyer,
        naam: junipNaam(r.customer),
        initiaal: ((r.customer && r.customer.first_name) || '?').trim().charAt(0).toUpperCase(),
        product: String(r.target_title || '').replace(/^CreatineCoffee\+\s*/, 'Creatine Coffee+ '),
        datum: Date.parse(r.created_at || 0) || 0,
        fotos: !!(r.photo_urls && r.photo_urls.length),
        videos: !!(r.video_urls && r.video_urls.length),
      };
    });
  }

  function junipKaart(r) {
    var kaart = document.createElement('article');
    kaart.className = 'v14-rev__kaart';

    /* De bron toont vijf sterren op 13px in de tekstkleur, nooit oranje.
       Hier staat het echte cijfer: een review van vier sterren als vijf
       tekenen is de styling kopiëren en de inhoud vervalsen. */
    var sterren = '';
    for (var i = 0; i < 5; i++) {
      /* De kleur hoort in het blad, niet hier: dit waren de laatste twee
         vaste hexwaarden in het script en ze liepen niet mee met de
         kleurwissel van punt 22. */
      sterren += '<svg viewBox="0 0 24 24" class="' + (i < r.rating ? 'is-vol' : 'is-leeg') +
        '"><path fill="currentColor" d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.3 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
    }

    kaart.innerHTML =
      '<div class="v14-rev__wie">' +
        '<span class="v14-rev__links">' +
          '<span class="v14-rev__av" aria-hidden="true"></span>' +
          '<span class="v14-rev__naam">' +
            '<b></b>' +
            (r.geverifieerd
              ? '<span class="v14-rev__ver"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10" fill="currentColor"/><path d="M7.5 12.5l3 3 6-6" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified buyer</span>'
              : '') +
          '</span>' +
        '</span>' +
        '<span class="v14-rev__kaartsterren" role="img" aria-label="' + r.rating + ' out of 5">' + sterren + '</span>' +
      '</div>' +
      '<h3 class="v14-rev__ttl"></h3><p class="v14-rev__tx"></p>';

    kaart.querySelector('.v14-rev__av').textContent = r.initiaal;
    kaart.querySelector('.v14-rev__naam b').textContent = r.naam;
    kaart.querySelector('.v14-rev__ttl').textContent = r.titel || '';
    kaart.querySelector('.v14-rev__tx').textContent = r.tekst || '';
    return kaart;
  }

  /* JUNIP VERZINT EEN TITEL als de bezoeker er geen gaf: dan staat het begin
     van de tekst in het titelveld met een beletselteken erachter. Gemeten op
     11 oktober 2026: 19 van de 36 reviews. In de lange lijst valt dat
     nauwelijks op, maar op drie kaarten naast elkaar lees je dezelfde zin dan
     twee keer onder elkaar. Daarom wegen die bij de keuze het lichtst. */
  function junipAuto(r) {
    var t = (r.titel || '').trim().replace(/[\s.…]+$/, '');
    var b = (r.tekst || '').trim();
    if (!t) return true;
    return b.toLowerCase().indexOf(t.toLowerCase()) === 0;
  }

  /* De keuze voor een korte uitstalling: nieuwste eerst, met een eigen titel en
     een tekst die de kolom niet uit de hoogte trekt. Zijn dat er te weinig, dan
     vallen die twee eisen weg -- liever een minder nette kaart dan een gat waar
     een review hoort staan. data-kies wint van alles: dan heeft de klant zelf
     gekozen, en de volgorde van die lijst is de volgorde op de pagina. */
  function junipKies(rij, aantal, maxTekens, ids) {
    var nieuw = rij.slice().sort(function (a, b) { return b.datum - a.datum; });
    if (ids.length) {
      var opId = [];
      ids.forEach(function (id) {
        nieuw.forEach(function (r) { if (r.id === id && opId.indexOf(r) < 0) opId.push(r); });
      });
      if (opId.length) return opId.slice(0, aantal);
    }
    var uit = nieuw.filter(function (r) {
      return r.titel && r.tekst && !junipAuto(r) && (!maxTekens || r.tekst.length <= maxTekens);
    }).slice(0, aantal);
    if (uit.length < aantal) {
      nieuw.forEach(function (r) {
        if (uit.length >= aantal || uit.indexOf(r) > -1 || !r.tekst) return;
        uit.push(r);
      });
    }
    return uit;
  }

  /* Het echte gemiddelde en het echte aantal, overal op de pagina waar een van
     de twee staat: de hero, de regel bij de video's, de kop van de reviewrij en
     het scoreblok. Een keer per pagina, want beide afnemers filteren hetzelfde
     en het eerste antwoord is dus ook het goede. */
  function junipCijfers(rij) {
    if (junipCijfersGezet || !rij.length) return;
    junipCijfersGezet = true;
    var gem = (rij.reduce(function (t, r) { return t + r.rating; }, 0) / rij.length).toFixed(1);
    alle('[data-v14-avg]').forEach(function (el) {
      el.textContent = el.textContent.indexOf('/') > -1 ? gem + '/5.0' : gem;
    });
    alle('[data-v14-junip-avg]').forEach(function (el) { el.textContent = gem; });
    alle('[data-v14-junip-count]').forEach(function (el) {
      el.textContent = rij.length.toLocaleString('en-US');
    });
  }

  var junip = document.querySelector('[data-v14-junip]');
  if (junip) {
    var sleutel = junip.getAttribute('data-store-key');
    var lijst = junip.querySelector('[data-v14-junip-lijst]');
    var meer = junip.querySelector('[data-v14-junip-meer]');
    var alles = [], toon = 4, sorteer = 'latest';

    function tekenReviews() {
      if (!lijst) return;
      var rij = alles.slice();
      if (sorteer === 'rating') rij.sort(function (a, b) { return b.rating - a.rating; });
      else if (sorteer === 'fotos') rij = rij.filter(function (r) { return r.fotos; });
      else if (sorteer === 'videos') rij = rij.filter(function (r) { return r.videos; });
      else rij.sort(function (a, b) { return b.datum - a.datum; });

      lijst.innerHTML = '';
      rij.slice(0, toon).forEach(function (r) { lijst.appendChild(junipKaart(r)); });
      lijst.hidden = rij.length === 0;
      if (meer) meer.hidden = rij.length <= toon;
    }

    if (sleutel) {
      junipHaal(sleutel).then(function (ruw) {
        /* Losse reviews overslaan op id. Het sterrencijfer zegt niets over de
           tekst: in de echte verzameling zit een review van vijf sterren
           waarvan de tekst een annuleringsverzoek is. Welke dat zijn is een
           keuze van de klant, dus dit staat leeg en wordt in de theme editor
           gevuld. */
        alles = junipVorm(ruw, junipKommas(junip, 'data-negeer'), junipKommas(junip, 'data-negeer-id'));
        if (!alles.length) return;
        junipCijfers(alles);

        var verd = junip.querySelector('[data-v14-junip-verdeling]');
        if (verd) {
          verd.hidden = false;
          for (var n = 1; n <= 5; n++) {
            var aantal = alles.filter(function (r) { return Math.round(r.rating) === n; }).length;
            var rijEl = verd.querySelector('[data-v14-junip-rij="' + n + '"]');
            if (!rijEl) continue;
            var pct = Math.round(aantal / alles.length * 100) + '%';
            rijEl.querySelector('.v14-rev__balk span').style.width = pct;
            rijEl.querySelector('[data-v14-junip-pct]').textContent = pct;
          }
        }

        /* een filter verdwijnt als geen enkele review eronder valt; een knop die
           gegarandeerd een lege lijst oplevert is erger dan geen knop. Nu per
           soort, want punt 22 splitst foto's en video's. */
        [['fotos', 'fotos'], ['videos', 'videos']].forEach(function (paar) {
          var knop = junip.querySelector('[data-v14-junip-sort="' + paar[0] + '"]');
          if (knop && !alles.some(function (r) { return r[paar[1]]; })) knop.hidden = true;
        });

        tekenReviews();
      }).catch(function () {
        /* stil: de sectie blijft staan met de terugvalwaarden, zonder lege kaders */
      });
    }

    alle('[data-v14-junip-sort]').forEach(function (b) {
      b.addEventListener('click', function () {
        sorteer = b.getAttribute('data-v14-junip-sort');
        alle('[data-v14-junip-sort]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        toon = 4;
        tekenReviews();
      });
    });
    if (meer) meer.addEventListener('click', function () { toon += 8; tekenReviews(); });
  }

  /* De korte uitstalling: de eerste paar echte reviews direct onder de video's
     op de homepage. Staat los van de lijst hierboven en werkt ook zonder die
     sectie, want hij draagt zijn eigen winkelsleutel.

     Geeft de API niets, of staat er geen sleutel, dan blijft het vak verborgen.
     Dat is dezelfde afspraak als voor de lange lijst: geen lege kaders. */
  alle('[data-v14-junip-top]').forEach(function (vak) {
    var sl = vak.getAttribute('data-store-key');
    if (!sl) return;
    var hoeveel = parseInt(vak.getAttribute('data-aantal'), 10) || 3;
    var maxTekens = parseInt(vak.getAttribute('data-max'), 10) || 0;
    var ids = junipKommas(vak, 'data-kies');
    /* "See more reviews" klapt deze rij verder uit. De knop staat buiten het vak
       en begint verborgen; hij komt pas als er echt meer te tonen is. Zo is er
       geen knop als de API niets geeft, en geen knop als alles al in beeld
       staat. Een stap is twee rijen van drie, dus tweemaal wat er begint. */
    var meerKnop = document.querySelector('[data-v14-junip-meertop]');
    var stap = Math.max(3, hoeveel * 2);
    var getoond = hoeveel;

    junipHaal(sl).then(function (ruw) {
      var rij = junipVorm(ruw, junipKommas(vak, 'data-negeer'), junipKommas(vak, 'data-negeer-id'));
      if (!rij.length) return;
      junipCijfers(rij);

      var teken = function () {
        var kies = junipKies(rij, getoond, maxTekens, ids);
        if (!kies.length) return false;
        vak.innerHTML = '';
        kies.forEach(function (r) { vak.appendChild(junipKaart(r)); });
        vak.hidden = false;
        /* Twee redenen om de knop weg te halen: alles staat er al, of er kwam
           minder terug dan gevraagd en dan is de bron op. Dat tweede geldt ook
           als de klant vaste review-id's heeft ingesteld; dan valt er per
           definitie niets uit te klappen. */
        if (meerKnop) meerKnop.hidden = kies.length >= rij.length || kies.length < getoond;
        return true;
      };

      if (!teken()) return;
      if (meerKnop) {
        meerKnop.addEventListener('click', function () {
          getoond += stap;
          teken();
        });
      }
    }).catch(function () {
      /* stil, net als hierboven */
    });
  });

  /* ── scroll-reveal: BEWUST UIT ────────────────────────────────────────────
     Hier stond een inloopanimatie: directe kinderen van elke sectie faden in
     zodra ze in beeld komen, met een stagger per kind. Die heeft nooit gedraaid.
     De selector was `.upgrd-v14 section`, maar de secties DRAGEN die klasse zelf,
     dus het was geen afstammeling maar hetzelfde element — gemeten 0 treffers
     tegen 10 voor `section.upgrd-v14`.

     Op 10 oktober 2026 is de selector gerepareerd en de animatie aangezet, en dat
     is weer teruggedraaid omdat het meetbaar iets ergers opleverde. Zodra de
     reveal draait compenseert de scroll-anchoring van Blink een geanimeerde
     hoogtewijziging niet meer volledig. Klik je onderin het laatste koopblok op
     One-Time, dan krimpt het document 199 (1440) tot 270px (390) doordat de
     planregels van het bovenste koopblok inklappen via de transitie op
     grid-template-rows (css:537), en schoot de zichtbare inhoud 62 tot 79px omhoog:

       zonder reveal   390px dOff -0,3   scrollY -135  |  1440px +0,5   -100
       met reveal      390px dOff -78,8  scrollY  -58  |  1440px -62,3   -39

     Vier gerichte oplossingen gemeten, geen enkele hielp: overflow-anchor:none op
     de gefadede elementen (-77,7), op de offer-modules (-78,8), alle inline
     reveal-stijlen wissen vlak voor de klik (-77,6), en de IntersectionObserver
     loskoppelen (-78,0). Alleen ALLE transities uitzetten haalde het weg (-1,3),
     en dat kost de hele pagina haar overgangen.

     Het blok staat daarom niet half gerepareerd te wachten maar is weg. Wie hem
     alsnog wil: repareer eerst de compensatie, niet de selector. Het attribuut
     data-v14-nofade op de herosectie is hierdoor zonder werking. */
  /* ── DE OFFERSECTIES VAN DE HOMEPAGE ────────────────────────────────────────
     De homepage biedt dezelfde producten heel anders aan dan de productpagina:
     geen koopblok met keuzes, maar kaarten die elk al een smaak en een aantal
     dragen. Alleen abonnement/eenmalig wisselt nog, en dat geldt voor de hele
     pagina tegelijk -- net zoals de twee koopblokken op de productpagina elkaar
     spiegelen, want anders staat er boven $49 en onderaan $90 voor hetzelfde.

     De verkoop zelf loopt door regelsVoorKeuze hierboven, met een expliciete
     keuze als tweede argument. Daardoor kan de homepage per definitie niet iets
     anders in de wagen leggen dan de productpagina: dezelfde varianten, hetzelfde
     verkoopplan, dezelfde cadeaus met dezelfde beschermende eigenschappen.

     DE KNOP REKENT AF, sinds 11 okt 2026 en op verzoek van de klant. Hij
     doorloopt dezelfde keten als de koopknop van de productpagina: legen,
     vullen, nalezen, en dan door naar de kassa. Hiervoor legde hij alleen in de
     wagen en opende hij de lade, en stond hier dat clear.js met opzet ontbrak.
     Dat is niet meer waar: er wordt wel geleegd, want dit is een pagina met één
     aanbod en twee klikken moeten geen twee bestellingen opstapelen. */
  (function () {
    var bakken = alle('[data-v14-hoffer]');
    if (!bakken.length) return;

    var modeNu = 'sub';

    var tekenBak = function (bak) {
      var P = lees(bak, 'data-prices');
      var sub = modeNu === 'sub';
      var perSub = bak.getAttribute('data-per-sub') || 'per cup';
      var perOnce = bak.getAttribute('data-per-once') || 'per cup';

      bak.setAttribute('data-mode', modeNu);

      alle('[data-v14-hkaart]', bak).forEach(function (kaart) {
        var q = kaart.getAttribute('data-qty') || '30';
        var pb = P[q] || {};
        var nu = kaart.querySelector('[data-v14-hnu]');
        var was = kaart.querySelector('[data-v14-hwas]');
        var per = kaart.querySelector('[data-v14-hper]');

        if (nu) nu.textContent = sub ? (pb.sub || '') : (pb.once || '');
        /* De doorgestreepte prijs is de EENMALIGE prijs, en staat er dus alleen
           bij een abonnement. In de eenmalige stand is er niets om tegen af te
           zetten en zou hij zijn eigen prijs doorstrepen. */
        if (was) {
          was.textContent = sub ? (pb.once || '') : '';
          was.hidden = !sub || !pb.once;
        }
        if (per) {
          var staart = (sub ? perSub : perOnce).replace('{d}', q);
          per.textContent = (pb.per || '') + ' ' + staart;
        }

        /* HET KNOPLABEL IS HETZELFDE ALS OP DE PRODUCTPAGINA: "Start now ·
           Just $49". Daar wordt het op dezelfde manier opgebouwd, zie het label
           bij [data-v14-ctalabel]. Het was "Get 60 servings · $49"; de klant
           wil overal dezelfde bewoording. De prijs komt uit dezelfde prijstabel
           als het bedrag erboven, dus de knop kan niet iets anders zeggen dan
           de kaart waar hij op staat. */
        var cta = kaart.querySelector('[data-v14-hctalabel]');
        if (cta) {
          var bedrag = sub ? (pb.sub || '') : (pb.once || '');
          var staartje = bedrag ? ' \u00b7 ' + bedrag : '';
          var vol = 'Start now' + (bedrag ? ' \u00b7 Just ' + bedrag : '');
          var kortaf = 'Start now' + staartje;
          cta.textContent = vol;
          var knopEl = cta.closest('[data-v14-hadd]');
          if (knopEl) {
            /* PAST HET NIET, DAN "Start now · $49" zonder het woord Just. Dat
               is dezelfde zin, alleen korter, en geen vierde bewoording erbij.
               Het label mag niet afbreken
               (white-space:nowrap in het blad), dus zonder deze terugval zou het
               op een smalle kaart over de rand lopen. Meten en niet gokken: de
               breedte van de knop min zijn eigen padding, de pijl en de goot is
               wat er voor de tekst overblijft, en scrollWidth is wat de tekst op
               een regel nodig heeft. Een halve pixel speling tegen afrondingen. */
            var cs = getComputedStyle(knopEl);
            var svg = knopEl.querySelector('svg');
            var goot = parseFloat(cs.columnGap || cs.gap || 0) || 0;
            var ruimte = knopEl.clientWidth
              - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0)
              - (svg ? svg.getBoundingClientRect().width + goot : 0);
            if (ruimte > 0 && cta.scrollWidth > ruimte + 0.5) cta.textContent = kortaf;
            /* De naam van de regel hoort in de toegankelijke naam te blijven.
               In de startlijst staan drie knoppen met dezelfde zichtbare tekst
               onder elkaar; zonder dit zijn ze voor een schermlezer niet uit
               elkaar te houden. */
            var naam = knopEl.getAttribute('data-naam');
            knopEl.setAttribute('aria-label', naam ? cta.textContent + ', ' + naam : cta.textContent);
          }
        }

        /* HET CADEAUBLOK VOLGT DE PERKS-TEKST VAN DIT AANTAL, niet een vaste
           zin. regelsVoorKeuze legt bij ELK abonnement de scoop erbij en bij 60
           servings ook de beker; p30_perk en p60_perk beschrijven precies dat.
           Stond hier eerder `sub && q === '60'`, en dan beloofde een kaart van
           30 servings niets terwijl de wagen wel een scoop meegaf.
           Geen perk-tekst voor dit aantal: dan is er niets te melden en gaat het
           blok weg in plaats van leeg te blijven staan. */
        var cadeau = kaart.querySelector('[data-v14-hcadeau]');
        if (cadeau) {
          var perks = pb.perks || '';
          cadeau.hidden = !perks;
          cadeau.setAttribute('data-aan', sub ? 'true' : 'false');

          /* DE WAARDE GAAT NAAR DE TWEEDE REGEL. "FREE Scoop + Thermo Cup (Worth
             $34)" is zoveel langer dan "FREE Scoop (Worth $7)" dat alleen die
             ene over twee regels liep; de kaart ernaast hield dan een lege regel
             over. Het voorbeeld van de klant doet het al goed: daar staat de
             naam op de titelregel en de waarde eronder ("Free * $34 value").

             Dus wordt de perk-tekst op het haakje gesplitst. Geen nieuwe copy en
             geen tweede instelling: het blijft letterlijk de tekst van de
             productpagina, alleen over twee regels verdeeld. Staat er geen
             haakje in, dan blijft de hele tekst gewoon de titel. */
          var m = perks.match(/^\s*(.*?)\s*\(([^)]*)\)\s*$/);
          var titel = m ? m[1] : perks;
          var waarde = m ? m[2] : '';

          var tit = cadeau.querySelector('[data-v14-hcadeautitel]');
          if (tit) tit.textContent = titel;
          var csub = cadeau.querySelector('[data-v14-hcadeausub]');
          if (csub) {
            var basis = csub.getAttribute(sub ? 'data-sub' : 'data-once') || '';
            csub.textContent = (sub && waarde) ? basis + ' \u00b7 ' + waarde : basis;
          }
        }
        /* Het merkje hoort bij de beste koop, en die is er alleen op abonnement.
           Welke kaart hem draagt bepaalt de instelling op het blok. */
        var best = kaart.querySelector('[data-v14-hbest]');
        if (best) best.hidden = !sub;
      });

      alle('[data-v14-hperk]', bak).forEach(function (el) {
        el.textContent = el.getAttribute(sub ? 'data-sub' : 'data-once') || '';
      });

      alle('[data-v14-hmode]', bak).forEach(function (b) {
        var aan = b.getAttribute('data-v14-hmode') === modeNu;
        b.setAttribute('aria-checked', aan ? 'true' : 'false');
        b.tabIndex = aan ? 0 : -1;                 /* roving tabindex, als bij het koopblok */
      });
      alle('[data-v14-hmodelink]', bak).forEach(function (a) {
        a.textContent = a.getAttribute(sub ? 'data-sub' : 'data-once') || '';
      });
    };

    var teken = function () { bakken.forEach(tekenBak); };

    var zetMode = function (m) {
      if (m !== 'sub' && m !== 'once') return;
      modeNu = m;
      teken();
    };

    /* ── de bediening ───────────────────────────────────────────────────── */
    bakken.forEach(function (bak) {
      bak.addEventListener('click', function (e) {
        var md = e.target.closest('[data-v14-hmode]');
        if (md) { zetMode(md.getAttribute('data-v14-hmode')); return; }
        var lnk = e.target.closest('[data-v14-hmodelink]');
        if (lnk) { e.preventDefault(); zetMode(modeNu === 'sub' ? 'once' : 'sub'); return; }
      });

      /* Pijltoetsen binnen de schakelaar, zoals in een echte radiogroep. */
      bak.addEventListener('keydown', function (e) {
        var r = e.target.closest('[data-v14-hmode]');
        if (!r) return;
        var rs = alle('[data-v14-hmode]', bak);
        var i = rs.indexOf(r), j;
        if (i < 0) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % rs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i + rs.length - 1) % rs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = rs.length - 1;
        else return;
        e.preventDefault();
        zetMode(rs[j].getAttribute('data-v14-hmode'));
        rs[j].focus();
      });
    });

    /* ── in de wagen leggen ─────────────────────────────────────────────── */
    /* Tekst op de knop zetten EN de toegankelijke naam meenemen. Zonder dat
       tweede blijft aria-label op de oude waarde staan, en aria-label wint van
       de inhoud: een schermlezer zou dan "Get 30 servings" horen terwijl er
       "Adding…" staat. data-naam houdt de smaak erbij in de startlijst, waar
       drie knoppen anders exact hetzelfde heten. */
    function zetKnoptekst(knop, lbl, tekst) {
      if (lbl) lbl.textContent = tekst; else knop.textContent = tekst;
      var naam = knop.getAttribute('data-naam');
      knop.setAttribute('aria-label', naam ? tekst + ', ' + naam : tekst);
    }

    var bezig = false;

    /* Zelfde verhaal als op de productpagina: komt de bezoeker met de terugknop
       van de kassa, dan staat deze grendel nog op true en blijft de kaart op
       "Adding…" staan. Zie de uitleg daar. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      bezig = false;
      alle('[data-v14-hadd]').forEach(function (k) {
        k.removeAttribute('aria-busy');
        if (k.__upgrdHerstel) { clearTimeout(k.__upgrdHerstel); k.__upgrdHerstel = 0; }
      });
      teken();
    });

    document.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-v14-hadd]');
      if (!knop) return;
      var kaart = knop.closest('[data-v14-hkaart]');
      var bak = knop.closest('[data-v14-hoffer]');
      if (!kaart || !bak) return;
      e.preventDefault();

      /* Dezelfde grendel als de koopknop: twee klikken achter elkaar leggen er
         anders twee keer hetzelfde in. */
      if (bezig) return;
      bezig = true;

      var keuze = {
        flavor: kaart.getAttribute('data-flavor') || 'o',
        qty: Number(kaart.getAttribute('data-qty') || 30),
        mode: modeNu,
      };
      /* BOTH DWINGT 60 AF, net als op de productpagina (zie f === 'm' daar).
         "Both" is een pouch van elke smaak, dus twee betaalde regels, en op 30
         servings zou dat twee pouches op het plan van 30 zetten: een andere
         prijs dan de kaart toont en een ander verkoopplan dan de klant koos.
         Vandaag heeft alleen de kaart van 60 die smaak, dus dit is een slot op
         een deur die nog dicht is -- maar hij staat open zodra iemand in de
         editor een kaart "Both" met 30 servings aanmaakt. */
      if (keuze.flavor === 'm') keuze.qty = 60;
      var regels = regelsVoorKeuze(bak, keuze);

      /* HETZELFDE PAD ALS DE PRODUCTPAGINA, op verzoek van de klant (11 okt
         2026). Hiervoor legde deze knop alleen iets in de wagen en opende hij
         de lade; nu loopt hij door dezelfde keten als de koopknop daar: de
         wagen legen, vullen, nalezen of er echt in ligt wat er gekozen is, en
         dan door naar de kassa. Lukt het nalezen niet, dan naar /cart in plaats
         van naar de kassa.

         Legen hoort erbij: dit is een pagina met één aanbod, en zonder legen
         stapelt een tweede klik of een terugkeer uit de kassa de aantallen op.
         Het staat hier altijd aan: data-leeg bestaat alleen op het koopblok van
         de productpagina, en deze secties zetten het niet. */
      knop.setAttribute('aria-busy', 'true');
      var lbl = knop.querySelector('[data-v14-hctalabel]');
      var bezigTekst = knop.getAttribute('data-label-bezig') || 'Adding…';
      zetKnoptekst(knop, lbl, bezigTekst);
      /* Een eerdere mislukking kan nog een timer open hebben staan die straks
         blind over dit label heen schrijft. */
      if (knop.__upgrdHerstel) { clearTimeout(knop.__upgrdHerstel); knop.__upgrdHerstel = 0; }

      koopKeten(bak, keuze, regels, 1).then(function (goed) {
        /* DE GRENDEL BLIJFT DICHT OP HET GESLAAGDE PAD. Navigeren is niet
           onmiddellijk: zet je bezig hier terug, dan kan er in de honderden
           milliseconden tot het verlaten van de pagina nog een klik door, en
           die leegt de wagen opnieuw terwijl de eerste keten al onderweg is.
           De productpagina doet dit om dezelfde reden niet. */
        if (!goed) { window.location.href = pad('cart'); return; }
        return afrekenPad().then(function (bestemming) { window.location.href = bestemming; });
      }).catch(function (err) {
        try { console.error('[upgrd-v14] kopen mislukt:', (err && err.message) || err,
                            '\n  keuze:', JSON.stringify(keuze),
                            '\n  regels:', JSON.stringify(regels)); } catch (x) {}
        /* NIET doorsturen als het vullen zelf faalde: de wagen is dan al
           geleegd en de bezoeker zou op een lege wagen landen zonder uitleg.
           Op de pagina blijven, het zeggen, en de knop teruggeven. */
        knop.removeAttribute('aria-busy');
        zetKnoptekst(knop, lbl, 'Something went wrong, tap to try again');
        /* De wagen is bij een mislukte poging wél geleegd, dus de teller in de
           header staat op een aantal dat niet meer bestaat. Bijwerken met wat
           er echt ligt. */
        if (typeof window.headerV1UpdateCartCount === 'function') {
          leesWagen().then(function (wagen) {
            window.headerV1UpdateCartCount(wagen && wagen.item_count || 0);
          }).catch(function () {});
        }
        /* teken() zet het juiste label terug -- het volledige of "Buy now",
           afhankelijk van de ruimte -- in plaats van een vaste tekst. */
        knop.__upgrdHerstel = setTimeout(function () { knop.__upgrdHerstel = 0; teken(); }, 3200);
        bezig = false;
      });
    });

    teken();
    /* De keuze tussen het volledige label en "Buy now" hangt van de breedte af,
       dus hij moet opnieuw gemaakt worden als het venster verandert. Anders
       blijft "Buy now" staan op een scherm dat inmiddels ruim genoeg is. */
    var klokje = 0;
    window.addEventListener('resize', function () {
      clearTimeout(klokje);
      klokje = setTimeout(teken, 150);
    });
  })();

  /* ── DE ACCORDEON IN DE HOMEPAGE-BENEFITS ──────────────────────────────────
     Vier items, altijd precies een open, met een beeldpaneel ernaast dat
     meewisselt. Alles dicht kan niet: klikken op de open rij zet dezelfde index
     opnieuw en verandert dus niets. Dat is wat het voorbeeld doet en wat
     role="tab" met aria-selected belooft.

     EEN TABLIST KRIJGT EEN ROVING TABINDEX en pijltoetsen. Het voorbeeld laat
     alle vier de knoppen in de tabvolgorde staan, maar dat is niet het patroon
     dat bij role="tablist" hoort -- en punt 4.3 van de audit heeft hetzelfde
     eerder voor de keuzegroepen in het koopblok rechtgezet. Dus hier dezelfde
     afspraak: een tabstop voor de hele lijst, pijlen eroverheen.

     Het openvouwen zelf zit in het blad (grid-template-rows 0fr/1fr), net als
     bij de planregels; hier wisselt alleen het attribuut. */
  alle('.v14-hben').forEach(function (sec) {
    var tabs = alle('[data-v14-hbentab]', sec);
    var beelden = alle('[data-v14-hbenbeeld]', sec);
    if (tabs.length < 2) return;

    /* huidig is niet alleen voor de snelheid. Zonder deze grendel schrijft elke
       muisbeweging over een al open rij dezelfde attributen opnieuw, en dan
       begint de overgang van 300ms in het blad telkens opnieuw aan dezelfde
       waarde. Dat is precies de fout die de duimnagelrail van de galerij
       schokkerig maakte. */
    var huidig = -1;

    var zet = function (i, focus) {
      if (i === huidig) {
        if (focus) tabs[i].focus();
        return;
      }
      huidig = i;
      tabs.forEach(function (t, j) {
        var aan = j === i;
        t.setAttribute('aria-selected', aan ? 'true' : 'false');
        t.tabIndex = aan ? 0 : -1;
      });
      beelden.forEach(function (b, j) { b.setAttribute('data-on', j === i ? 'true' : 'false'); });
      if (focus) tabs[i].focus();
    };

    sec.addEventListener('click', function (e) {
      var t = e.target.closest('[data-v14-hbentab]');
      if (!t) return;
      zet(tabs.indexOf(t));
    });

    /* OPENEN OP HOVER, op verzoek van de klant (11 okt 2026). Het voorbeeld
       doet dit niet -- daar staat geen enkele muis-afhandeling in -- dus de
       vorm hieronder is een keuze, en dit is waarom hij zo is:

       ALLEEN BIJ EEN ECHTE AANWIJZER. Op een aanraakscherm vuurt mouseover
       alsnog vlak voor de tik, en dan zou de rij onder je vinger al openvallen
       voordat de tik aankomt. (hover: hover) and (pointer: fine) sluit dat uit;
       daar blijft het klikken.

       MET EEN WACHTTIJD VAN 90ms. De vier rijen staan onder elkaar, dus de weg
       naar de onderste gaat over de rijen ertussen. Zonder wachttijd opent elke
       passerende rij, duwt de rij eronder weg terwijl je ernaartoe beweegt, en
       lopen er vier overgangen van 300ms door elkaar. 90ms is korter dan een
       bewuste pauze en langer dan het oversteken van een rij.

       EN EEN NACONTROLE. Tussen het mikken en het openen verschuift de pagina:
       de oude rij klapt dicht en de nieuwe open. :hover zegt op dat moment waar
       de muis ECHT is, dus dat is wat telt, niet waar hij 90ms geleden was. */
    var fijn = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
    if (fijn && fijn.matches) {
      var klok = 0, gemikt = -1;
      var stop = function () { clearTimeout(klok); gemikt = -1; };

      sec.addEventListener('mouseover', function (e) {
        var t = e.target.closest('[data-v14-hbentab]');
        if (!t) return;
        var i = tabs.indexOf(t);
        /* Terug op de rij die al openstaat: dan is een lopende afspraak naar een
           andere rij van de baan. */
        if (i < 0 || i === huidig) return stop();
        /* Dezelfde rij als waar de klok al voor loopt: niets doen. mouseover
           vuurt ook voor elke span in de rij, en opnieuw beginnen zou betekenen
           dat de rij nooit opengaat zolang de muis binnen de rij beweegt. */
        if (i === gemikt) return;
        clearTimeout(klok);
        gemikt = i;
        klok = setTimeout(function () {
          gemikt = -1;
          if (t.matches(':hover')) zet(i);
        }, 90);
      });

      sec.addEventListener('mouseleave', stop);
    }

    sec.addEventListener('keydown', function (e) {
      var t = e.target.closest('[data-v14-hbentab]');
      if (!t) return;
      var i = tabs.indexOf(t), n = tabs.length, j;
      if (i < 0) return;
      /* aria-orientation is vertical, dus Omhoog en Omlaag zijn de hoofdpijlen;
         Links en Rechts doen hetzelfde omdat een bezoeker die net zo goed kan
         proberen. Rondlopend, net als de keuzegroepen in het koopblok. */
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') j = (i + n - 1) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      else return;
      e.preventDefault();
      zet(j, true);
    });

    /* De begintoestand ook door zet() laten lopen, zodat de tabindex meteen
       klopt en het pilletje bij het eerste item hoort. */
    var start = 0;
    tabs.forEach(function (t, j) { if (t.getAttribute('aria-selected') === 'true') start = j; });
    zet(start);
  });

  /* ── DE HOOGTE VAN DE BALK EN DE HEADER ────────────────────────────
     De homepage-hero staat op schermhoogte, en de aftrek daarvan is wat erboven
     staat. Dat is geen vast getal: de balktekst komt uit de theme-editor, en een
     langere tekst laat de balk wrappen. Gemeten 119px tot 1024 en 120,13px
     daarboven; upgrd-v14.css houdt 120px aan als terugvaloptie zodat er niets
     verspringt voordat dit draait. Hier wordt de echte hoogte nagemeten.

     Alleen fixed en absolute vallen af: die nemen geen hoogte in de flow in en
     duwen de hero dus ook niet omlaag. sticky doet dat wél en telt dus mee.

     Doet niets op een pagina zonder hero -- de productpagina gebruikt dit token
     niet, en dan hoeft er ook niets gemeten te worden. */
  (function () {
    if (!document.querySelector('.v14-hhero')) return;
    /* DE WIKKEL EN NIET DE HEADER ZELF, en de marges tellen mee. Sinds de kop
       over de inhoud zweeft draagt .upgrd-v14-hdrwrap een negatieve ondermarge
       ter hoogte van zichzelf: hij staat er wel, maar hij duwt niets omlaag.
       Alleen de hoogte meten gaf dan 120px chroom terwijl de hero in
       werkelijkheid op 59px begint, en de hero werd een kop te kort. Hoogte plus
       marges geeft hier precies 0 voor de kop, en het blijft kloppen als die
       marge ooit weer verdwijnt. De balk zit niet in zo'n wikkel en valt terug
       op zichzelf. */
    var meubels = alle('.v14-bar, .v14-hdr').map(function (el) {
      return el.closest('.upgrd-v14-hdrwrap') || el;
    });
    if (!meubels.length) return;
    var zet = function () {
      var h = 0;
      meubels.forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position === 'fixed' || cs.position === 'absolute') return;
        h += el.getBoundingClientRect().height +
             (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
      });
      document.documentElement.style.setProperty('--v14-chroom', h.toFixed(2) + 'px');
    };
    zet();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(zet);
      meubels.forEach(function (el) { ro.observe(el); });
    } else {
      window.addEventListener('resize', zet);
    }
  })();
})();
